const BorderLight = "1px solid #a4b1b8";
const BorderLightHc = "1px solid #6b7882";
const BorderDark = "1px solid #8a97a0";
const BorderDarkHc = "1px solid #bbc7cd";
const BorderThickS = "1px";
const BorderThickM = "2px";
const BorderThickL = "4px";
const BorderRadiusNone = "0px";
const BorderRadiusS = "3px";
const BorderRadiusM = "4px";
const BorderRadiusL = "8px";

const Border = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderLight: BorderLight,
    BorderLightHc: BorderLightHc,
    BorderDark: BorderDark,
    BorderDarkHc: BorderDarkHc,
    BorderThickS: BorderThickS,
    BorderThickM: BorderThickM,
    BorderThickL: BorderThickL,
    BorderRadiusNone: BorderRadiusNone,
    BorderRadiusS: BorderRadiusS,
    BorderRadiusM: BorderRadiusM,
    BorderRadiusL: BorderRadiusL
});

const ColorOrange100 = "#fee3dc";
const ColorOrange200 = "#fda891";
const ColorOrange300 = "#ff8f70";
const ColorOrange400 = "#fc7753";
const ColorOrange500 = "#fa4616"; // Primary Brand Orange
const ColorOrange600 = "#da3b11";
const ColorOrange700 = "#c2320c";
const ColorOrange800 = "#832107";
const ColorOrange850 = "#3c383c";
const ColorOrange100Contrast = "#182027";
const ColorOrange200Contrast = "#182027";
const ColorOrange300Contrast = "#182027";
const ColorOrange400Contrast = "#182027";
const ColorOrange500Contrast = "#182027";
const ColorOrange600Contrast = "#f4f9fa";
const ColorOrange700Contrast = "#f4f9fa";
const ColorOrange800Contrast = "#f4f9fa";
const ColorBlue100 = "#dae8fa";
const ColorBlue200 = "#badaff";
const ColorBlue300 = "#87bfff";
const ColorBlue400 = "#66adff";
const ColorBlue500 = "#0067df";
const ColorBlue600 = "#0056ba";
const ColorBlue700 = "#00489d";
const ColorBlue800 = "#00336f";
const ColorBlue050 = "#f5f9fe";
const ColorBlue050Contrast = "#1b2630";
const ColorBlue100Contrast = "#182027";
const ColorBlue200Contrast = "#182027";
const ColorBlue300Contrast = "#182027";
const ColorBlue400Contrast = "#182027";
const ColorBlue500Contrast = "#f4f9fa";
const ColorBlue600Contrast = "#f4f9fa";
const ColorBlue700Contrast = "#f4f9fa";
const ColorBlue800Contrast = "#f4f9fa";
const ColorBlueSecondary100 = "#e9f1fa";
const ColorBlueSecondary200 = "#b2d2f3";
const ColorBlueSecondary300 = "#8cc2f8";
const ColorBlueSecondary400 = "#42a1ff";
const ColorBlueSecondary500 = "#1976d2"; // Brand Accessory Blue Secondary
const ColorBlueSecondary600 = "#1665b3";
const ColorBlueSecondary700 = "#11508d";
const ColorBlueSecondary800 = "#0c3761";
const ColorBlueSecondary100Contrast = "#182027";
const ColorBlueSecondary200Contrast = "#182027";
const ColorBlueSecondary300Contrast = "#182027";
const ColorBlueSecondary400Contrast = "#182027";
const ColorBlueSecondary500Contrast = "#f4f9fa";
const ColorBlueSecondary600Contrast = "#f4f9fa";
const ColorBlueSecondary700Contrast = "#f4f9fa";
const ColorBlueSecondary800Contrast = "#f4f9fa";
const ColorGreen100 = "#eeffe5";
const ColorGreen200 = "#e4f2dd";
const ColorGreen250 = "#e4f2dd";
const ColorGreen300 = "#b4e89b";
const ColorGreen400 = "#74c94b";
const ColorGreen500 = "#6eb84a";
const ColorGreen600 = "#539d2f";
const ColorGreen700 = "#038108";
const ColorGreen750 = "#038a08";
const ColorGreen800 = "#005603";
const ColorGreen250Contrast = "#182027";
const ColorGreen500Contrast = "#182027";
const ColorGreen750Contrast = "#f4f9fa";
const ColorGreen050Contrast = "#182027";
const ColorGreen050 = "#eeffe6";
const ColorGreenEmerald = "#176245";
const ColorYellow100 = "#fff3db";
const ColorYellow200 = "#ffe19e";
const ColorYellow300 = "#ffca55";
const ColorYellow400 = "#ffbb27";
const ColorYellow500 = "#ffb40e"; // Brand Accessory Yellow
const ColorYellow600 = "#f3ab0d";
const ColorYellow700 = "#9e6100";
const ColorYellow750 = "#b27d09";
const ColorYellow800 = "#745107";
const ColorYellow100Contrast = "#182027";
const ColorYellow200Contrast = "#182027";
const ColorYellow300Contrast = "#182027";
const ColorYellow400Contrast = "#182027";
const ColorYellow500Contrast = "#182027";
const ColorYellow600Contrast = "#182027";
const ColorYellow700Contrast = "#182027";
const ColorYellow800Contrast = "#f4f9fa";
const ColorRed100 = "#fff0f1";
const ColorRed200 = "#ffd1d1";
const ColorRed300 = "#ffadad";
const ColorRed400 = "#ff8484";
const ColorRed500 = "#cc3d45"; // Brand Accessory Red
const ColorRed600 = "#b6242b";
const ColorRed700 = "#a6040a";
const ColorRed800 = "#6c0004";
const ColorRed100Contrast = "#182027";
const ColorRed200Contrast = "#182027";
const ColorRed300Contrast = "#182027";
const ColorRed400Contrast = "#182027";
const ColorRed500Contrast = "#f4f9fa";
const ColorRed600Contrast = "#f4f9fa";
const ColorRed700Contrast = "#f4f9fa";
const ColorRed800Contrast = "#f4f9fa";
const ColorPurple100 = "#eee1ee";
const ColorPurple200 = "#edb8ed";
const ColorPurple300 = "#dc80db";
const ColorPurple400 = "#b748b6";
const ColorPurple500 = "#933692";
const ColorPurple600 = "#8c338b";
const ColorPurple700 = "#662565";
const ColorPurple800 = "#491b49";
const ColorPurple100Contrast = "#182027";
const ColorPurple200Contrast = "#182027";
const ColorPurple300Contrast = "#182027";
const ColorPurple400Contrast = "#f4f9fa";
const ColorPurple500Contrast = "#f4f9fa";
const ColorPurple600Contrast = "#f4f9fa";
const ColorPurple700Contrast = "#f4f9fa";
const ColorPurple800Contrast = "#f4f9fa";
const ColorLightBlue100 = "#e1f6fd";
const ColorLightBlue200 = "#afe8fa";
const ColorLightBlue300 = "#73d6f7";
const ColorLightBlue400 = "#44cffc";
const ColorLightBlue500 = "#38c6f4";
const ColorLightBlue600 = "#35bbe7";
const ColorLightBlue700 = "#278aab";
const ColorLightBlue800 = "#1c637a";
const ColorLightBlue100Contrast = "#182027";
const ColorLightBlue200Contrast = "#182027";
const ColorLightBlue300Contrast = "#182027";
const ColorLightBlue400Contrast = "#182027";
const ColorLightBlue500Contrast = "#182027";
const ColorLightBlue600Contrast = "#182027";
const ColorLightBlue700Contrast = "#182027";
const ColorLightBlue800Contrast = "#f4f9fa";
const ColorWhite = "#ffffff";
const ColorBlack = "#000000";
const ColorError100 = "#fff0f1";
const ColorError200 = "#ffd1d1";
const ColorError250 = "#ffa2a8";
const ColorError300 = "#ffadad";
const ColorError400 = "#ff8484";
const ColorError500 = "#cc3d45";
const ColorError600 = "#b6242b";
const ColorError700 = "#a6040a";
const ColorError750 = "#a6040a";
const ColorError800 = "#6c0004";
const ColorError250Contrast = "#182027";
const ColorError500Contrast = "#182027";
const ColorError750Contrast = "#f4f9fa";
const ColorError050Contrast = "#182027";
const ColorError050 = "#ffe6e7";
const ColorWarning100 = "#fff3db";
const ColorWarning200 = "#ffe19e";
const ColorWarning300 = "#ffca55";
const ColorWarning400 = "#ffbb27";
const ColorWarning500 = "#ffb40e"; // Brand Accessory Yellow
const ColorWarning600 = "#f3ab0d";
const ColorWarning700 = "#b27d09";
const ColorWarning750 = "#b27d09";
const ColorWarning800 = "#805a07";
const ColorWarning100Contrast = "#182027";
const ColorWarning200Contrast = "#182027";
const ColorWarning300Contrast = "#182027";
const ColorWarning400Contrast = "#182027";
const ColorWarning500Contrast = "#182027";
const ColorWarning600Contrast = "#182027";
const ColorWarning700Contrast = "#182027";
const ColorWarning800Contrast = "#f4f9fa";
const ColorInfo100 = "#e9f1fa";
const ColorInfo200 = "#b2d2f3";
const ColorInfo300 = "#8cc2f8";
const ColorInfo400 = "#42a1ff";
const ColorInfo500 = "#1976d2"; // Brand Accessory Blue Secondary
const ColorInfo600 = "#1665b3";
const ColorInfo700 = "#11508d";
const ColorInfo800 = "#0c3761";
const ColorInfo100Contrast = "#182027";
const ColorInfo200Contrast = "#182027";
const ColorInfo300Contrast = "#182027";
const ColorInfo400Contrast = "#182027";
const ColorInfo500Contrast = "#182027";
const ColorInfo600Contrast = "#f4f9fa";
const ColorInfo700Contrast = "#f4f9fa";
const ColorInfo800Contrast = "#f4f9fa";
const ColorSuccess100 = "#eeffe5";
const ColorSuccess200 = "#e4f2dd";
const ColorSuccess250 = "#e4f2dd";
const ColorSuccess300 = "#b4e89b";
const ColorSuccess400 = "#74c94b";
const ColorSuccess500 = "#6eb84a";
const ColorSuccess600 = "#539d2f";
const ColorSuccess700 = "#038108";
const ColorSuccess750 = "#038a08";
const ColorSuccess800 = "#005603";
const ColorSuccess250Contrast = "#182027";
const ColorSuccess500Contrast = "#182027";
const ColorSuccess750Contrast = "#f4f9fa";
const ColorSuccess050Contrast = "#182027";
const ColorSuccess050 = "#eeffe6";
const ColorGray100 = "#f7f7f7";
const ColorGray150 = "#f4f4f5";
const ColorGray200 = "#ecedee";
const ColorGray250 = "#e1e2e4";
const ColorGray300 = "#d3d4d6";
const ColorGray350 = "#c0c2c5";
const ColorGray400 = "#aaacaf";
const ColorGray450 = "#919295";
const ColorGray500 = "#757679";
const ColorGray550 = "#595a5c";
const ColorGray600 = "#414244";
const ColorGray650 = "#2d2e2f";
const ColorGray700 = "#1d1d1e";
const ColorGray750 = "#111212";
const ColorGray800 = "#0a0a0a";
const ColorGray850 = "#060606";
const ColorGray100Contrast = "#182027";
const ColorGray150Contrast = "#182027";
const ColorGray200Contrast = "#182027";
const ColorGray250Contrast = "#182027";
const ColorGray300Contrast = "#182027";
const ColorGray350Contrast = "#182027";
const ColorGray400Contrast = "#182027";
const ColorGray450Contrast = "#182027";
const ColorGray500Contrast = "#f4f9fa";
const ColorGray550Contrast = "#f4f9fa";
const ColorGray600Contrast = "#f4f9fa";
const ColorGray650Contrast = "#f4f9fa";
const ColorGray700Contrast = "#f4f9fa";
const ColorGray750Contrast = "#f4f9fa";
const ColorGray800Contrast = "#f4f9fa";
const ColorGray850Contrast = "#f4f9fa";
const ColorGray050Contrast = "#182027";
const ColorGray050 = "#fafafa";
const ColorInk100 = "#f8f9fa";
const ColorInk150 = "#f4f5f7";
const ColorInk200 = "#e9f0f3";
const ColorInk250 = "#dee6ea";
const ColorInk300 = "#cfd8dd";
const ColorInk350 = "#bbc7cd";
const ColorInk400 = "#a4b1b8";
const ColorInk450 = "#8a97a0";
const ColorInk500 = "#6b7882";
const ColorInk550 = "#526069";
const ColorInk600 = "#374652";
const ColorInk625 = "#374652"; // DEPRECATED - Please use ColorInk600 instead.
const ColorInk650 = "#273139";
const ColorInk700 = "#182027";
const ColorInk750 = "#0e1419";
const ColorInk800 = "#080c10";
const ColorInk850 = "#04070a";
const ColorInk100Contrast = "#182027";
const ColorInk150Contrast = "#182027";
const ColorInk200Contrast = "#182027";
const ColorInk250Contrast = "#182027";
const ColorInk300Contrast = "#182027";
const ColorInk350Contrast = "#182027";
const ColorInk400Contrast = "#182027";
const ColorInk450Contrast = "#182027";
const ColorInk500Contrast = "#f4f9fa";
const ColorInk550Contrast = "#f4f9fa";
const ColorInk600Contrast = "#f4f9fa";
const ColorInk650Contrast = "#f4f9fa";
const ColorInk700Contrast = "#f4f9fa";
const ColorInk750Contrast = "#f4f9fa";
const ColorInk800Contrast = "#f4f9fa";
const ColorInk850Contrast = "#f4f9fa";
const ColorInk050Contrast = "#182027";
const ColorInk050 = "#182027";
const ColorPink100 = "#fcdbe6";
const ColorPink200 = "#f7a1bd";
const ColorPink300 = "#fd7da7";
const ColorPink400 = "#f25a8c";
const ColorPink500 = "#ed145b";
const ColorPink600 = "#d91153";
const ColorPink700 = "#a60e3f";
const ColorPink800 = "#76092d";
const ColorBrandPrimary = "#fa4616"; // Brand color direct from marketing.
const ColorBrandSecondary = "#0067df"; // Brand color direct from marketing.
const ColorBrandNeutralWhite = "#ffffff";
const ColorBrandNeutralBlack = "#000000";
const ColorBrandNeutralDarkGray = "#595a5c";
const ColorBrandNeutralPaleGray = "#e1e2e4";
const ColorBrandNeutralLightGray = "#f4f5f7";
const ColorBrandAccessoryRed = "#cc3d45";
const ColorBrandAccessoryYellow = "#ffb40e";
const ColorBrandAccessoryPurple = "#933692";
const ColorBrandAccessoryLightBlue = "#38c6f4";
const ColorBackgroundLight = "#ffffff";
const ColorBackgroundLightHc = "#ffffff";
const ColorBackgroundDark = "#182027";
const ColorBackgroundDarkHc = "#182027";
const ColorBackgroundSecondaryLight = "#f4f5f7";
const ColorBackgroundSecondaryLightHc = "#f4f5f7";
const ColorBackgroundSecondaryDark = "#273139";
const ColorBackgroundSecondaryDarkHc = "#273139";
const ColorBackgroundInverseLight = "#182027";
const ColorBackgroundInverseLightHc = "#182027";
const ColorBackgroundInverseDark = "#f8f9fa";
const ColorBackgroundInverseDarkHc = "#f8f9fa";
const ColorBackgroundGrayLight = "#cfd8dd";
const ColorBackgroundGrayLightHc = "#cfd8dd";
const ColorBackgroundGrayDark = "#526069";
const ColorBackgroundGrayDarkHc = "#374652";
const ColorBackgroundDisabledLight = "#ecedee";
const ColorBackgroundDisabledLightHc = "#ecedee";
const ColorBackgroundDisabledDark = "#273139";
const ColorBackgroundDisabledDarkHc = "#273139";
const ColorBackgroundHighlightLight = "#fee3dc";
const ColorBackgroundHighlightLightHc = "#fee3dc";
const ColorBackgroundHighlightDark = "#3c383c";
const ColorBackgroundHighlightDarkHc = "#3c383c";
const ColorBackgroundRaisedLight = "#ffffff";
const ColorBackgroundRaisedLightHc = "#ffffff";
const ColorBackgroundRaisedDark = "#273139";
const ColorBackgroundRaisedDarkHc = "#273139";
const ColorBackgroundEditLight = "#ffffff";
const ColorBackgroundEditLightHc = "#ffffff";
const ColorBackgroundEditDark = "#00000099";
const ColorBackgroundEditDarkHc = "#00000099";
const ColorBackgroundGrayEmpLight = "#a4b1b8";
const ColorBackgroundGrayEmpLightHc = "#a4b1b8";
const ColorBackgroundGrayEmpDark = "#8a97a0";
const ColorBackgroundGrayEmpDarkHc = "#a4b1b8";
const ColorBackgroundHoverLight = "#52606914"; // 14 hex = 0.08 Opacity
const ColorBackgroundHoverLightHc = "#52606914"; // 14 hex = 0.08 Opacity
const ColorBackgroundHoverDark = "#cfd8dd14"; // 14 hex = 0.08 Opacity
const ColorBackgroundHoverDarkHc = "#a4b1b814"; // 14 hex = 0.08 Opacity
const ColorBackgroundPressedLight = "#5260691f"; // 1f hex = 0.12 Opacity
const ColorBackgroundPressedLightHc = "#5260691f"; // 1f hex = 0.12 Opacity
const ColorBackgroundPressedDark = "#cfd8dd1f"; // 1f hex = 0.12 Opacity
const ColorBackgroundPressedDarkHc = "#cfd8dd1f"; // 1f hex = 0.12 Opacity
const ColorBackgroundSelectedLight = "#e9f1fa";
const ColorBackgroundSelectedLightHc = "#e9f1fa";
const ColorBackgroundSelectedDark = "#374652";
const ColorBackgroundSelectedDarkHc = "#374652";
const ColorSelectionIndicatorLight = "#0067df";
const ColorSelectionIndicatorLightHc = "#00489d";
const ColorSelectionIndicatorDark = "#66adff";
const ColorSelectionIndicatorDarkHc = "#dae8fa";
const ColorNotificationBadgeLight = "#000000";
const ColorNotificationBadgeLightHc = "#000000";
const ColorNotificationBadgeDark = "#ffffff";
const ColorNotificationBadgeDarkHc = "#ffffff";
const ColorNotificationIndicatorLight = "#da3b11";
const ColorNotificationIndicatorLightHc = "#832107";
const ColorNotificationIndicatorDark = "#ff8f70";
const ColorNotificationIndicatorDarkHc = "#ff8f70";
const ColorHoverLight = "#e9f1fa";
const ColorHoverLightHc = "#e9f1fa";
const ColorHoverDark = "#374652";
const ColorHoverDarkHc = "#273139";
const ColorCurtainLight = "#000000";
const ColorCurtainLightHc = "#000000";
const ColorCurtainDark = "#000000";
const ColorCurtainDarkHc = "#000000";
const ColorBorderLight = "#a4b1b8";
const ColorBorderLightHc = "#6b7882";
const ColorBorderDark = "#8a97a0";
const ColorBorderDarkHc = "#bbc7cd";
const ColorBorderDisabledLight = "#cfd8dd";
const ColorBorderDisabledLightHc = "#cfd8dd";
const ColorBorderDisabledDark = "#526069";
const ColorBorderDisabledDarkHc = "#8a97a0";
const ColorBorderGridLight = "#f4f5f7";
const ColorBorderGridLightHc = "#f4f5f7";
const ColorBorderGridDark = "#273139";
const ColorBorderGridDarkHc = "#273139";
const ColorBorderDeEmpLight = "#cfd8dd";
const ColorBorderDeEmpLightHc = "#a4b1b8";
const ColorBorderDeEmpDark = "#526069";
const ColorBorderDeEmpDarkHc = "#a4b1b8";
const ColorSelectionLight = "#da3b11";
const ColorSelectionLightHc = "#832107";
const ColorSelectionDark = "#ff8f70";
const ColorSelectionDarkHc = "#fda891";
const ColorLogoLight = "#fa4616";
const ColorLogoLightHc = "#fa4616";
const ColorLogoDark = "#ffffff";
const ColorLogoDarkHc = "#ffffff";
const ColorForegroundLight = "#273139";
const ColorForegroundLightHc = "#273139";
const ColorForegroundDark = "#f4f5f7";
const ColorForegroundDarkHc = "#f4f5f7";
const ColorForegroundLightLight = "#6b7882";
const ColorForegroundLightLightHc = "#374652";
const ColorForegroundLightDark = "#a4b1b8";
const ColorForegroundLightDarkHc = "#bbc7cd";
const ColorForegroundEmpLight = "#182027";
const ColorForegroundEmpLightHc = "#182027";
const ColorForegroundEmpDark = "#f8f9fa";
const ColorForegroundEmpDarkHc = "#f8f9fa";
const ColorForegroundDeEmpLight = "#526069";
const ColorForegroundDeEmpLightHc = "#374652";
const ColorForegroundDeEmpDark = "#cfd8dd";
const ColorForegroundDeEmpDarkHc = "#e9f0f3";
const ColorForegroundDisableLight = "#8a97a0";
const ColorForegroundDisableLightHc = "#8a97a0";
const ColorForegroundDisableDark = "#a4b1b8";
const ColorForegroundDisableDarkHc = "#a4b1b8";
const ColorForegroundInverseLight = "#f8f9fa";
const ColorForegroundInverseLightHc = "#f8f9fa";
const ColorForegroundInverseDark = "#182027";
const ColorForegroundInverseDarkHc = "#182027";
const ColorForegroundHighlightLight = "#da3b11";
const ColorForegroundHighlightLightHc = "#832107";
const ColorForegroundHighlightDark = "#ff8f70";
const ColorForegroundHighlightDarkHc = "#ff8f70";
const ColorForegroundHighlightSelectedLight = "#da3b111a";
const ColorForegroundHighlightSelectedLightHc = "#8321071a";
const ColorForegroundHighlightSelectedDark = "#ff8f701a";
const ColorForegroundHighlightSelectedDarkHc = "#ff8f701a";
const ColorForegroundHighlightSelectedHoverLight = "#da3b1126";
const ColorForegroundHighlightSelectedHoverLightHc = "#83210726";
const ColorForegroundHighlightSelectedHoverDark = "#ff8f7026";
const ColorForegroundHighlightSelectedHoverDarkHc = "#ff8f7026";
const ColorForegroundLinkLight = "#0067df";
const ColorForegroundLinkLightHc = "#00489d";
const ColorForegroundLinkDark = "#66adff";
const ColorForegroundLinkDarkHc = "#66adff";
const ColorForegroundLinkPressedLight = "#00489d";
const ColorForegroundLinkPressedLightHc = "#00336f";
const ColorForegroundLinkPressedDark = "#badaff";
const ColorForegroundLinkPressedDarkHc = "#badaff";
const ColorForegroundInvDeEmpLight = "#cfd8dd";
const ColorForegroundInvDeEmpLightHc = "#cfd8dd";
const ColorForegroundInvDeEmpDark = "#526069";
const ColorForegroundInvDeEmpDarkHc = "#374652";
const ColorPrimaryLight = "#0067df";
const ColorPrimaryLightHc = "#00489d";
const ColorPrimaryDark = "#66adff";
const ColorPrimaryDarkHc = "#badaff";
const ColorPrimaryLighterLight = "#badaff";
const ColorPrimaryLighterLightHc = "#badaff";
const ColorPrimaryLighterDark = "#00489d";
const ColorPrimaryLighterDarkHc = "#00336f";
const ColorPrimaryDarkerLight = "#00489d";
const ColorPrimaryDarkerLightHc = "#11508d";
const ColorPrimaryDarkerDark = "#badaff";
const ColorPrimaryDarkerDarkHc = "#badaff";
const ColorPrimaryHoverLight = "#0056ba";
const ColorPrimaryHoverLightHc = "#00336f";
const ColorPrimaryHoverDark = "#87bfff";
const ColorPrimaryHoverDarkHc = "#87bfff";
const ColorPrimaryFocusedLight = "#0056ba";
const ColorPrimaryFocusedLightHc = "#00336f";
const ColorPrimaryFocusedDark = "#87bfff";
const ColorPrimaryFocusedDarkHc = "#87bfff";
const ColorPrimaryPressedLight = "#0067df";
const ColorPrimaryPressedLightHc = "#00336f";
const ColorPrimaryPressedDark = "#66adff";
const ColorPrimaryPressedDarkHc = "#66adff";
const ColorSecondaryFocusedLight = "#e9f1fa";
const ColorSecondaryFocusedLightHc = "#e9f1fa";
const ColorSecondaryFocusedDark = "#374652";
const ColorSecondaryFocusedDarkHc = "#273139";
const ColorSecondaryPressedLight = "#b2d2f3";
const ColorSecondaryPressedLightHc = "#b2d2f3";
const ColorSecondaryPressedDark = "#11508d";
const ColorSecondaryPressedDarkHc = "#11508d";
const ColorChipDefaultBackgroundLight = "#cfd8dd";
const ColorChipDefaultBackgroundLightHc = "#cfd8dd";
const ColorChipDefaultBackgroundDark = "#526069";
const ColorChipDefaultBackgroundDarkHc = "#526069";
const ColorChipErrorBackgroundLight = "#fff0f1";
const ColorChipErrorBackgroundLightHc = "#fff0f1";
const ColorChipErrorBackgroundDark = "#000000";
const ColorChipErrorBackgroundDarkHc = "#000000";
const ColorChipWarningBackgroundLight = "#fff3db";
const ColorChipWarningBackgroundLightHc = "#fff3db";
const ColorChipWarningBackgroundDark = "#000000";
const ColorChipWarningBackgroundDarkHc = "#000000";
const ColorChipInfoBackgroundLight = "#e9f1fa";
const ColorChipInfoBackgroundLightHc = "#e9f1fa";
const ColorChipInfoBackgroundDark = "#000000";
const ColorChipInfoBackgroundDarkHc = "#000000";
const ColorChipSuccessBackgroundLight = "#eeffe5";
const ColorChipSuccessBackgroundLightHc = "#eeffe5";
const ColorChipSuccessBackgroundDark = "#000000";
const ColorChipSuccessBackgroundDarkHc = "#000000";
const ColorErrorIconLight = "#cc3d45";
const ColorErrorIconLightHc = "#a6040a";
const ColorErrorIconDark = "#ff8484";
const ColorErrorIconDarkHc = "#ffadad";
const ColorErrorIconInverseLight = "#ff8484";
const ColorErrorIconInverseLightHc = "#ff8484";
const ColorErrorIconInverseDark = "#cc3d45";
const ColorErrorIconInverseDarkHc = "#b6242b";
const ColorErrorTextLight = "#a6040a";
const ColorErrorTextLightHc = "#a6040a";
const ColorErrorTextDark = "#ff8484";
const ColorErrorTextDarkHc = "#ffadad";
const ColorErrorBackgroundLight = "#fff0f1";
const ColorErrorBackgroundLightHc = "#fff0f1";
const ColorErrorBackgroundDark = "#000000";
const ColorErrorBackgroundDarkHc = "#000000";
const ColorErrorForegroundInverseLight = "#ff8484";
const ColorErrorForegroundInverseLightHc = "#ff8484";
const ColorErrorForegroundInverseDark = "#cc3d45";
const ColorErrorForegroundInverseDarkHc = "#b6242b";
const ColorInfoForegroundLight = "#1665b3";
const ColorInfoForegroundLightHc = "#11508d";
const ColorInfoForegroundDark = "#42a1ff";
const ColorInfoForegroundDarkHc = "#42a1ff";
const ColorInfoIconLight = "#1976d2";
const ColorInfoIconLightHc = "#11508d";
const ColorInfoIconDark = "#42a1ff";
const ColorInfoIconDarkHc = "#8cc2f8";
const ColorInfoIconInverseLight = "#42a1ff";
const ColorInfoIconInverseLightHc = "#42a1ff";
const ColorInfoIconInverseDark = "#1976d2";
const ColorInfoIconInverseDarkHc = "#0056ba";
const ColorInfoTextLight = "#1665b3";
const ColorInfoTextLightHc = "#11508d";
const ColorInfoTextDark = "#42a1ff";
const ColorInfoTextDarkHc = "#42a1ff";
const ColorInfoForegroundInverseLight = "#42a1ff";
const ColorInfoForegroundInverseLightHc = "#42a1ff";
const ColorInfoForegroundInverseDark = "#1976d2";
const ColorInfoForegroundInverseDarkHc = "#8cc2f8";
const ColorInfoBackgroundLight = "#e9f1fa";
const ColorInfoBackgroundLightHc = "#e9f1fa";
const ColorInfoBackgroundDark = "#000000";
const ColorInfoBackgroundDarkHc = "#000000";
const ColorSuccessIconLight = "#038108";
const ColorSuccessIconLightHc = "#005603";
const ColorSuccessIconDark = "#74c94b";
const ColorSuccessIconDarkHc = "#74c94b";
const ColorSuccessIconInverseLight = "#74c94b";
const ColorSuccessIconInverseLightHc = "#74c94b";
const ColorSuccessIconInverseDark = "#038108";
const ColorSuccessIconInverseDarkHc = "#6eb84a";
const ColorSuccessTextLight = "#038108";
const ColorSuccessTextLightHc = "#005603";
const ColorSuccessTextDark = "#74c94b";
const ColorSuccessTextDarkHc = "#74c94b";
const ColorSuccessBackgroundLight = "#eeffe5";
const ColorSuccessBackgroundLightHc = "#eeffe5";
const ColorSuccessBackgroundDark = "#000000";
const ColorSuccessBackgroundDarkHc = "#000000";
const ColorSuccessForegroundInverseLight = "#74c94b";
const ColorSuccessForegroundInverseLightHc = "#74c94b";
const ColorSuccessForegroundInverseDark = "#6eb84a";
const ColorSuccessForegroundInverseDarkHc = "#6eb84a";
const ColorWarningIconLight = "#ffb40e";
const ColorWarningIconLightHc = "#745107";
const ColorWarningIconDark = "#ffbb27";
const ColorWarningIconDarkHc = "#ffbb27";
const ColorWarningIconInverseLight = "#ffbb27";
const ColorWarningIconInverseLightHc = "#ffbb27";
const ColorWarningIconInverseDark = "#ffb40e";
const ColorWarningIconInverseDarkHc = "#ffb40e";
const ColorWarningTextLight = "#9e6100";
const ColorWarningTextLightHc = "#273139";
const ColorWarningTextDark = "#ffe19e";
const ColorWarningTextDarkHc = "#ffe19e";
const ColorWarningBackgroundLight = "#fff3db";
const ColorWarningBackgroundLightHc = "#fff3db";
const ColorWarningBackgroundDark = "#000000";
const ColorWarningBackgroundDarkHc = "#000000";
const ColorWarningForegroundInverseLight = "#ffbb27";
const ColorWarningForegroundInverseLightHc = "#ffbb27";
const ColorWarningForegroundInverseDark = "#ffb40e";
const ColorWarningForegroundInverseDarkHc = "#ffb40e";
const ColorIconDefaultLight = "#526069";
const ColorIconDefaultLightHc = "#374652";
const ColorIconDefaultDark = "#cfd8dd";
const ColorIconDefaultDarkHc = "#e9f0f3";
const ColorIconInvertedDefaultLight = "#cfd8dd";
const ColorIconInvertedDefaultLightHc = "#cfd8dd";
const ColorIconInvertedDefaultDark = "#526069";
const ColorIconInvertedDefaultDarkHc = "#374652";
const ColorToggleOffHoverLight = "#52606914";
const ColorToggleOffHoverLightHc = "#52606914";
const ColorToggleOffHoverDark = "#cfd8dd14";
const ColorToggleOffHoverDarkHc = "#cfd8dd14";
const ColorToggleOffFocusLight = "#52606914";
const ColorToggleOffFocusLightHc = "#52606914";
const ColorToggleOffFocusDark = "#cfd8dd14";
const ColorToggleOffFocusDarkHc = "#cfd8dd14";
const ColorToggleOffPressedLight = "#5260691f";
const ColorToggleOffPressedLightHc = "#5260691f";
const ColorToggleOffPressedDark = "#cfd8dd1f";
const ColorToggleOffPressedDarkHc = "#cfd8dd1f";
const ColorToggleOnHoverLight = "#0067df14";
const ColorToggleOnHoverLightHc = "#0067df14";
const ColorToggleOnHoverDark = "#66adff14";
const ColorToggleOnHoverDarkHc = "#66adff14";
const ColorToggleOnFocusLight = "#0067df14";
const ColorToggleOnFocusLightHc = "#0067df14";
const ColorToggleOnFocusDark = "#66adff14";
const ColorToggleOnFocusDarkHc = "#66adff14";
const ColorToggleOnPressedLight = "#0067df1f";
const ColorToggleOnPressedLightHc = "#0067df1f";
const ColorToggleOnPressedDark = "#66adff1f";
const ColorToggleOnPressedDarkHc = "#66adff1f";
const ColorCalloutBackgroundLight = "#00489d";
const ColorCalloutBackgroundLightHc = "#00489d";
const ColorCalloutBackgroundDark = "#00489d";
const ColorCalloutBackgroundDarkHc = "#00489d";
const ColorWarnLight = "#b6242b";
const ColorWarnLightHc = "#b6242b";
const ColorWarnDark = "#ff8484";
const ColorWarnDarkHc = "#ffadad";
const ColorWarnDarkerLight = "#a6040a";
const ColorWarnDarkerLightHc = "#a6040a";
const ColorWarnDarkerDark = "#ffadad";
const ColorWarnDarkerDarkHc = "#ffadad";
const ColorWarnHoverLight = "#b6242b0a";
const ColorWarnHoverLightHc = "#b6242b0a";
const ColorWarnHoverDark = "#ff84840a";
const ColorWarnHoverDarkHc = "#ff84840a";
const ColorWarnFocusLight = "#b6242b1f";
const ColorWarnFocusLightHc = "#b6242b1f";
const ColorWarnFocusDark = "#ff84841f";
const ColorWarnFocusDarkHc = "#ff84841f";
const ColorWarnPressedLight = "#b6242b14";
const ColorWarnPressedLightHc = "#b6242b14";
const ColorWarnPressedDark = "#ff848414";
const ColorWarnPressedDarkHc = "#ff848414";
const ColorCarouselBackgroundLight = "#f5f9fe";
const ColorCarouselBackgroundLightHc = "#f5f9fe";
const ColorCarouselBackgroundDark = "#1b2630";
const ColorCarouselBackgroundDarkHc = "#1b2630";
const ColorIconButtonHoverLight = "#52606914";
const ColorIconButtonHoverLightHc = "#52606914";
const ColorIconButtonHoverDark = "#cfd8dd14";
const ColorIconButtonHoverDarkHc = "#cfd8dd14";
const ColorIconButtonFocusLight = "#52606914";
const ColorIconButtonFocusLightHc = "#52606914";
const ColorIconButtonFocusDark = "#cfd8dd14";
const ColorIconButtonFocusDarkHc = "#cfd8dd14";
const ColorIconButtonPressedLight = "#5260691f";
const ColorIconButtonPressedLightHc = "#5260691f";
const ColorIconButtonPressedDark = "#cfd8dd1f";
const ColorIconButtonPressedDarkHc = "#cfd8dd1f";
const ColorCodeFunctionLight = "#b748b6";
const ColorCodeFunctionLightHc = "#8c338b";
const ColorCodeFunctionDark = "#dc80db";
const ColorCodeFunctionDarkHc = "#dc80db";
const ColorCodeOperatorLight = "#0067df";
const ColorCodeOperatorLightHc = "#00489d";
const ColorCodeOperatorDark = "#66adff";
const ColorCodeOperatorDarkHc = "#66adff";
const ColorCodeNumericLight = "#1e7f5a";
const ColorCodeNumericLightHc = "#176245";
const ColorCodeNumericDark = "#6ecdb6";
const ColorCodeNumericDarkHc = "#6ecdb6";
const ColorCodeTextLight = "#d91153";
const ColorCodeTextLightHc = "#a60e3f";
const ColorCodeTextDark = "#f25a8c";
const ColorCodeTextDarkHc = "#fd7da7";
const ColorToggleThumbOffLight = "#526069";
const ColorToggleThumbOffLightHc = "#374652";
const ColorToggleThumbOffDark = "#cfd8dd";
const ColorToggleThumbOffDarkHc = "#cfd8dd";
const ColorToggleTrackOffLight = "#cfd8dd";
const ColorToggleTrackOffLightHc = "#cfd8dd";
const ColorToggleTrackOffDark = "#526069";
const ColorToggleTrackOffDarkHc = "#526069";
const ColorToggleThumbOnLight = "#0067df";
const ColorToggleThumbOnLightHc = "#00489d";
const ColorToggleThumbOnDark = "#66adff";
const ColorToggleThumbOnDarkHc = "#66adff";
const ColorToggleTrackOnLight = "#badaff";
const ColorToggleTrackOnLightHc = "#badaff";
const ColorToggleTrackOnDark = "#00489d";
const ColorToggleTrackOnDarkHc = "#00489d";
const ColorToggleThumbOffDisabledLight = "#cfd8dd";
const ColorToggleThumbOffDisabledLightHc = "#cfd8dd";
const ColorToggleThumbOffDisabledDark = "#526069";
const ColorToggleThumbOffDisabledDarkHc = "#526069";
const ColorToggleTrackOffDisabledLight = "#ecedee";
const ColorToggleTrackOffDisabledLightHc = "#ecedee";
const ColorToggleTrackOffDisabledDark = "#374652";
const ColorToggleTrackOffDisabledDarkHc = "#374652";
const ColorToggleThumbOnDisabledLight = "#0067df47";
const ColorToggleThumbOnDisabledLightHc = "#0067df47";
const ColorToggleThumbOnDisabledDark = "#66adff47";
const ColorToggleThumbOnDisabledDarkHc = "#66adff47";
const ColorToggleTrackOnDisabledLight = "#badaff61";
const ColorToggleTrackOnDisabledLightHc = "#badaff61";
const ColorToggleTrackOnDisabledDark = "#00489d61";
const ColorToggleTrackOnDisabledDarkHc = "#00489d61";
const ColorSkeletonLight = "#ecedee";
const ColorSkeletonLightHc = "#ecedee";
const ColorSkeletonDark = "#273139";
const ColorSkeletonDarkHc = "#273139";
const ColorSkeletonGlowLight = "#fbfbfc";
const ColorSkeletonGlowLightHc = "#fbfbfc";
const ColorSkeletonGlowDark = "#525a61";
const ColorSkeletonGlowDarkHc = "#525a61";
const ColorDataGridHoverLight = "#f1f2f3";
const ColorDataGridHoverLightHc = "#f1f2f3";
const ColorDataGridHoverDark = "#272f36";
const ColorDataGridHoverDarkHc = "#272f36";
const ColorDataGridPressedLight = "#eaeced";
const ColorDataGridPressedLightHc = "#eaeced";
const ColorDataGridPressedDark = "#2e363d";
const ColorDataGridPressedDarkHc = "#2e363d";
const ColorFocusIndicatorLight = "#0067df";
const ColorFocusIndicatorLightHc = "#00489d";
const ColorFocusIndicatorDark = "#66adff";
const ColorFocusIndicatorDarkHc = "#b2d2f3";
const ColorFocusIndicatorInverseLight = "#66adff";
const ColorFocusIndicatorInverseLightHc = "#badaff";
const ColorFocusIndicatorInverseDark = "#0067df";
const ColorFocusIndicatorInverseDarkHc = "#0067df";
const ColorChartPurpleLight = "#933692";
const ColorChartPurpleLightHc = "#8c338b";
const ColorChartPurpleDark = "#b748b6";
const ColorChartPurpleDarkHc = "#dc80db";
const ColorChartPinkLight = "#ed145b";
const ColorChartPinkLightHc = "#d91153";
const ColorChartPinkDark = "#f25a8c";
const ColorChartPinkDarkHc = "#fd7da7";
const ColorChartBlueSecondaryLight = "#42a1ff";
const ColorChartBlueSecondaryLightHc = "#1976d2";
const ColorChartBlueSecondaryDark = "#42a1ff";
const ColorChartBlueSecondaryDarkHc = "#8cc2f8";
const ColorChartLightBlueLight = "#38c6f4";
const ColorChartLightBlueLightHc = "#278aab";
const ColorChartLightBlueDark = "#44cffc";
const ColorChartLightBlueDarkHc = "#44cffc";
const ColorChartGreenLight = "#6eb84a";
const ColorChartGreenLightHc = "#038108";
const ColorChartGreenDark = "#74c94b";
const ColorChartGreenDarkHc = "#74c94b";
const ColorChartYellowLight = "#ffb40e";
const ColorChartYellowLightHc = "#9e6100";
const ColorChartYellowDark = "#ffbb27";
const ColorChartYellowDarkHc = "#ffbb27";

const Colors = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ColorOrange100: ColorOrange100,
    ColorOrange200: ColorOrange200,
    ColorOrange300: ColorOrange300,
    ColorOrange400: ColorOrange400,
    ColorOrange500: ColorOrange500,
    ColorOrange600: ColorOrange600,
    ColorOrange700: ColorOrange700,
    ColorOrange800: ColorOrange800,
    ColorOrange850: ColorOrange850,
    ColorOrange100Contrast: ColorOrange100Contrast,
    ColorOrange200Contrast: ColorOrange200Contrast,
    ColorOrange300Contrast: ColorOrange300Contrast,
    ColorOrange400Contrast: ColorOrange400Contrast,
    ColorOrange500Contrast: ColorOrange500Contrast,
    ColorOrange600Contrast: ColorOrange600Contrast,
    ColorOrange700Contrast: ColorOrange700Contrast,
    ColorOrange800Contrast: ColorOrange800Contrast,
    ColorBlue100: ColorBlue100,
    ColorBlue200: ColorBlue200,
    ColorBlue300: ColorBlue300,
    ColorBlue400: ColorBlue400,
    ColorBlue500: ColorBlue500,
    ColorBlue600: ColorBlue600,
    ColorBlue700: ColorBlue700,
    ColorBlue800: ColorBlue800,
    ColorBlue050: ColorBlue050,
    ColorBlue050Contrast: ColorBlue050Contrast,
    ColorBlue100Contrast: ColorBlue100Contrast,
    ColorBlue200Contrast: ColorBlue200Contrast,
    ColorBlue300Contrast: ColorBlue300Contrast,
    ColorBlue400Contrast: ColorBlue400Contrast,
    ColorBlue500Contrast: ColorBlue500Contrast,
    ColorBlue600Contrast: ColorBlue600Contrast,
    ColorBlue700Contrast: ColorBlue700Contrast,
    ColorBlue800Contrast: ColorBlue800Contrast,
    ColorBlueSecondary100: ColorBlueSecondary100,
    ColorBlueSecondary200: ColorBlueSecondary200,
    ColorBlueSecondary300: ColorBlueSecondary300,
    ColorBlueSecondary400: ColorBlueSecondary400,
    ColorBlueSecondary500: ColorBlueSecondary500,
    ColorBlueSecondary600: ColorBlueSecondary600,
    ColorBlueSecondary700: ColorBlueSecondary700,
    ColorBlueSecondary800: ColorBlueSecondary800,
    ColorBlueSecondary100Contrast: ColorBlueSecondary100Contrast,
    ColorBlueSecondary200Contrast: ColorBlueSecondary200Contrast,
    ColorBlueSecondary300Contrast: ColorBlueSecondary300Contrast,
    ColorBlueSecondary400Contrast: ColorBlueSecondary400Contrast,
    ColorBlueSecondary500Contrast: ColorBlueSecondary500Contrast,
    ColorBlueSecondary600Contrast: ColorBlueSecondary600Contrast,
    ColorBlueSecondary700Contrast: ColorBlueSecondary700Contrast,
    ColorBlueSecondary800Contrast: ColorBlueSecondary800Contrast,
    ColorGreen100: ColorGreen100,
    ColorGreen200: ColorGreen200,
    ColorGreen250: ColorGreen250,
    ColorGreen300: ColorGreen300,
    ColorGreen400: ColorGreen400,
    ColorGreen500: ColorGreen500,
    ColorGreen600: ColorGreen600,
    ColorGreen700: ColorGreen700,
    ColorGreen750: ColorGreen750,
    ColorGreen800: ColorGreen800,
    ColorGreen250Contrast: ColorGreen250Contrast,
    ColorGreen500Contrast: ColorGreen500Contrast,
    ColorGreen750Contrast: ColorGreen750Contrast,
    ColorGreen050Contrast: ColorGreen050Contrast,
    ColorGreen050: ColorGreen050,
    ColorGreenEmerald: ColorGreenEmerald,
    ColorYellow100: ColorYellow100,
    ColorYellow200: ColorYellow200,
    ColorYellow300: ColorYellow300,
    ColorYellow400: ColorYellow400,
    ColorYellow500: ColorYellow500,
    ColorYellow600: ColorYellow600,
    ColorYellow700: ColorYellow700,
    ColorYellow750: ColorYellow750,
    ColorYellow800: ColorYellow800,
    ColorYellow100Contrast: ColorYellow100Contrast,
    ColorYellow200Contrast: ColorYellow200Contrast,
    ColorYellow300Contrast: ColorYellow300Contrast,
    ColorYellow400Contrast: ColorYellow400Contrast,
    ColorYellow500Contrast: ColorYellow500Contrast,
    ColorYellow600Contrast: ColorYellow600Contrast,
    ColorYellow700Contrast: ColorYellow700Contrast,
    ColorYellow800Contrast: ColorYellow800Contrast,
    ColorRed100: ColorRed100,
    ColorRed200: ColorRed200,
    ColorRed300: ColorRed300,
    ColorRed400: ColorRed400,
    ColorRed500: ColorRed500,
    ColorRed600: ColorRed600,
    ColorRed700: ColorRed700,
    ColorRed800: ColorRed800,
    ColorRed100Contrast: ColorRed100Contrast,
    ColorRed200Contrast: ColorRed200Contrast,
    ColorRed300Contrast: ColorRed300Contrast,
    ColorRed400Contrast: ColorRed400Contrast,
    ColorRed500Contrast: ColorRed500Contrast,
    ColorRed600Contrast: ColorRed600Contrast,
    ColorRed700Contrast: ColorRed700Contrast,
    ColorRed800Contrast: ColorRed800Contrast,
    ColorPurple100: ColorPurple100,
    ColorPurple200: ColorPurple200,
    ColorPurple300: ColorPurple300,
    ColorPurple400: ColorPurple400,
    ColorPurple500: ColorPurple500,
    ColorPurple600: ColorPurple600,
    ColorPurple700: ColorPurple700,
    ColorPurple800: ColorPurple800,
    ColorPurple100Contrast: ColorPurple100Contrast,
    ColorPurple200Contrast: ColorPurple200Contrast,
    ColorPurple300Contrast: ColorPurple300Contrast,
    ColorPurple400Contrast: ColorPurple400Contrast,
    ColorPurple500Contrast: ColorPurple500Contrast,
    ColorPurple600Contrast: ColorPurple600Contrast,
    ColorPurple700Contrast: ColorPurple700Contrast,
    ColorPurple800Contrast: ColorPurple800Contrast,
    ColorLightBlue100: ColorLightBlue100,
    ColorLightBlue200: ColorLightBlue200,
    ColorLightBlue300: ColorLightBlue300,
    ColorLightBlue400: ColorLightBlue400,
    ColorLightBlue500: ColorLightBlue500,
    ColorLightBlue600: ColorLightBlue600,
    ColorLightBlue700: ColorLightBlue700,
    ColorLightBlue800: ColorLightBlue800,
    ColorLightBlue100Contrast: ColorLightBlue100Contrast,
    ColorLightBlue200Contrast: ColorLightBlue200Contrast,
    ColorLightBlue300Contrast: ColorLightBlue300Contrast,
    ColorLightBlue400Contrast: ColorLightBlue400Contrast,
    ColorLightBlue500Contrast: ColorLightBlue500Contrast,
    ColorLightBlue600Contrast: ColorLightBlue600Contrast,
    ColorLightBlue700Contrast: ColorLightBlue700Contrast,
    ColorLightBlue800Contrast: ColorLightBlue800Contrast,
    ColorWhite: ColorWhite,
    ColorBlack: ColorBlack,
    ColorError100: ColorError100,
    ColorError200: ColorError200,
    ColorError250: ColorError250,
    ColorError300: ColorError300,
    ColorError400: ColorError400,
    ColorError500: ColorError500,
    ColorError600: ColorError600,
    ColorError700: ColorError700,
    ColorError750: ColorError750,
    ColorError800: ColorError800,
    ColorError250Contrast: ColorError250Contrast,
    ColorError500Contrast: ColorError500Contrast,
    ColorError750Contrast: ColorError750Contrast,
    ColorError050Contrast: ColorError050Contrast,
    ColorError050: ColorError050,
    ColorWarning100: ColorWarning100,
    ColorWarning200: ColorWarning200,
    ColorWarning300: ColorWarning300,
    ColorWarning400: ColorWarning400,
    ColorWarning500: ColorWarning500,
    ColorWarning600: ColorWarning600,
    ColorWarning700: ColorWarning700,
    ColorWarning750: ColorWarning750,
    ColorWarning800: ColorWarning800,
    ColorWarning100Contrast: ColorWarning100Contrast,
    ColorWarning200Contrast: ColorWarning200Contrast,
    ColorWarning300Contrast: ColorWarning300Contrast,
    ColorWarning400Contrast: ColorWarning400Contrast,
    ColorWarning500Contrast: ColorWarning500Contrast,
    ColorWarning600Contrast: ColorWarning600Contrast,
    ColorWarning700Contrast: ColorWarning700Contrast,
    ColorWarning800Contrast: ColorWarning800Contrast,
    ColorInfo100: ColorInfo100,
    ColorInfo200: ColorInfo200,
    ColorInfo300: ColorInfo300,
    ColorInfo400: ColorInfo400,
    ColorInfo500: ColorInfo500,
    ColorInfo600: ColorInfo600,
    ColorInfo700: ColorInfo700,
    ColorInfo800: ColorInfo800,
    ColorInfo100Contrast: ColorInfo100Contrast,
    ColorInfo200Contrast: ColorInfo200Contrast,
    ColorInfo300Contrast: ColorInfo300Contrast,
    ColorInfo400Contrast: ColorInfo400Contrast,
    ColorInfo500Contrast: ColorInfo500Contrast,
    ColorInfo600Contrast: ColorInfo600Contrast,
    ColorInfo700Contrast: ColorInfo700Contrast,
    ColorInfo800Contrast: ColorInfo800Contrast,
    ColorSuccess100: ColorSuccess100,
    ColorSuccess200: ColorSuccess200,
    ColorSuccess250: ColorSuccess250,
    ColorSuccess300: ColorSuccess300,
    ColorSuccess400: ColorSuccess400,
    ColorSuccess500: ColorSuccess500,
    ColorSuccess600: ColorSuccess600,
    ColorSuccess700: ColorSuccess700,
    ColorSuccess750: ColorSuccess750,
    ColorSuccess800: ColorSuccess800,
    ColorSuccess250Contrast: ColorSuccess250Contrast,
    ColorSuccess500Contrast: ColorSuccess500Contrast,
    ColorSuccess750Contrast: ColorSuccess750Contrast,
    ColorSuccess050Contrast: ColorSuccess050Contrast,
    ColorSuccess050: ColorSuccess050,
    ColorGray100: ColorGray100,
    ColorGray150: ColorGray150,
    ColorGray200: ColorGray200,
    ColorGray250: ColorGray250,
    ColorGray300: ColorGray300,
    ColorGray350: ColorGray350,
    ColorGray400: ColorGray400,
    ColorGray450: ColorGray450,
    ColorGray500: ColorGray500,
    ColorGray550: ColorGray550,
    ColorGray600: ColorGray600,
    ColorGray650: ColorGray650,
    ColorGray700: ColorGray700,
    ColorGray750: ColorGray750,
    ColorGray800: ColorGray800,
    ColorGray850: ColorGray850,
    ColorGray100Contrast: ColorGray100Contrast,
    ColorGray150Contrast: ColorGray150Contrast,
    ColorGray200Contrast: ColorGray200Contrast,
    ColorGray250Contrast: ColorGray250Contrast,
    ColorGray300Contrast: ColorGray300Contrast,
    ColorGray350Contrast: ColorGray350Contrast,
    ColorGray400Contrast: ColorGray400Contrast,
    ColorGray450Contrast: ColorGray450Contrast,
    ColorGray500Contrast: ColorGray500Contrast,
    ColorGray550Contrast: ColorGray550Contrast,
    ColorGray600Contrast: ColorGray600Contrast,
    ColorGray650Contrast: ColorGray650Contrast,
    ColorGray700Contrast: ColorGray700Contrast,
    ColorGray750Contrast: ColorGray750Contrast,
    ColorGray800Contrast: ColorGray800Contrast,
    ColorGray850Contrast: ColorGray850Contrast,
    ColorGray050Contrast: ColorGray050Contrast,
    ColorGray050: ColorGray050,
    ColorInk100: ColorInk100,
    ColorInk150: ColorInk150,
    ColorInk200: ColorInk200,
    ColorInk250: ColorInk250,
    ColorInk300: ColorInk300,
    ColorInk350: ColorInk350,
    ColorInk400: ColorInk400,
    ColorInk450: ColorInk450,
    ColorInk500: ColorInk500,
    ColorInk550: ColorInk550,
    ColorInk600: ColorInk600,
    ColorInk625: ColorInk625,
    ColorInk650: ColorInk650,
    ColorInk700: ColorInk700,
    ColorInk750: ColorInk750,
    ColorInk800: ColorInk800,
    ColorInk850: ColorInk850,
    ColorInk100Contrast: ColorInk100Contrast,
    ColorInk150Contrast: ColorInk150Contrast,
    ColorInk200Contrast: ColorInk200Contrast,
    ColorInk250Contrast: ColorInk250Contrast,
    ColorInk300Contrast: ColorInk300Contrast,
    ColorInk350Contrast: ColorInk350Contrast,
    ColorInk400Contrast: ColorInk400Contrast,
    ColorInk450Contrast: ColorInk450Contrast,
    ColorInk500Contrast: ColorInk500Contrast,
    ColorInk550Contrast: ColorInk550Contrast,
    ColorInk600Contrast: ColorInk600Contrast,
    ColorInk650Contrast: ColorInk650Contrast,
    ColorInk700Contrast: ColorInk700Contrast,
    ColorInk750Contrast: ColorInk750Contrast,
    ColorInk800Contrast: ColorInk800Contrast,
    ColorInk850Contrast: ColorInk850Contrast,
    ColorInk050Contrast: ColorInk050Contrast,
    ColorInk050: ColorInk050,
    ColorPink100: ColorPink100,
    ColorPink200: ColorPink200,
    ColorPink300: ColorPink300,
    ColorPink400: ColorPink400,
    ColorPink500: ColorPink500,
    ColorPink600: ColorPink600,
    ColorPink700: ColorPink700,
    ColorPink800: ColorPink800,
    ColorBrandPrimary: ColorBrandPrimary,
    ColorBrandSecondary: ColorBrandSecondary,
    ColorBrandNeutralWhite: ColorBrandNeutralWhite,
    ColorBrandNeutralBlack: ColorBrandNeutralBlack,
    ColorBrandNeutralDarkGray: ColorBrandNeutralDarkGray,
    ColorBrandNeutralPaleGray: ColorBrandNeutralPaleGray,
    ColorBrandNeutralLightGray: ColorBrandNeutralLightGray,
    ColorBrandAccessoryRed: ColorBrandAccessoryRed,
    ColorBrandAccessoryYellow: ColorBrandAccessoryYellow,
    ColorBrandAccessoryPurple: ColorBrandAccessoryPurple,
    ColorBrandAccessoryLightBlue: ColorBrandAccessoryLightBlue,
    ColorBackgroundLight: ColorBackgroundLight,
    ColorBackgroundLightHc: ColorBackgroundLightHc,
    ColorBackgroundDark: ColorBackgroundDark,
    ColorBackgroundDarkHc: ColorBackgroundDarkHc,
    ColorBackgroundSecondaryLight: ColorBackgroundSecondaryLight,
    ColorBackgroundSecondaryLightHc: ColorBackgroundSecondaryLightHc,
    ColorBackgroundSecondaryDark: ColorBackgroundSecondaryDark,
    ColorBackgroundSecondaryDarkHc: ColorBackgroundSecondaryDarkHc,
    ColorBackgroundInverseLight: ColorBackgroundInverseLight,
    ColorBackgroundInverseLightHc: ColorBackgroundInverseLightHc,
    ColorBackgroundInverseDark: ColorBackgroundInverseDark,
    ColorBackgroundInverseDarkHc: ColorBackgroundInverseDarkHc,
    ColorBackgroundGrayLight: ColorBackgroundGrayLight,
    ColorBackgroundGrayLightHc: ColorBackgroundGrayLightHc,
    ColorBackgroundGrayDark: ColorBackgroundGrayDark,
    ColorBackgroundGrayDarkHc: ColorBackgroundGrayDarkHc,
    ColorBackgroundDisabledLight: ColorBackgroundDisabledLight,
    ColorBackgroundDisabledLightHc: ColorBackgroundDisabledLightHc,
    ColorBackgroundDisabledDark: ColorBackgroundDisabledDark,
    ColorBackgroundDisabledDarkHc: ColorBackgroundDisabledDarkHc,
    ColorBackgroundHighlightLight: ColorBackgroundHighlightLight,
    ColorBackgroundHighlightLightHc: ColorBackgroundHighlightLightHc,
    ColorBackgroundHighlightDark: ColorBackgroundHighlightDark,
    ColorBackgroundHighlightDarkHc: ColorBackgroundHighlightDarkHc,
    ColorBackgroundRaisedLight: ColorBackgroundRaisedLight,
    ColorBackgroundRaisedLightHc: ColorBackgroundRaisedLightHc,
    ColorBackgroundRaisedDark: ColorBackgroundRaisedDark,
    ColorBackgroundRaisedDarkHc: ColorBackgroundRaisedDarkHc,
    ColorBackgroundEditLight: ColorBackgroundEditLight,
    ColorBackgroundEditLightHc: ColorBackgroundEditLightHc,
    ColorBackgroundEditDark: ColorBackgroundEditDark,
    ColorBackgroundEditDarkHc: ColorBackgroundEditDarkHc,
    ColorBackgroundGrayEmpLight: ColorBackgroundGrayEmpLight,
    ColorBackgroundGrayEmpLightHc: ColorBackgroundGrayEmpLightHc,
    ColorBackgroundGrayEmpDark: ColorBackgroundGrayEmpDark,
    ColorBackgroundGrayEmpDarkHc: ColorBackgroundGrayEmpDarkHc,
    ColorBackgroundHoverLight: ColorBackgroundHoverLight,
    ColorBackgroundHoverLightHc: ColorBackgroundHoverLightHc,
    ColorBackgroundHoverDark: ColorBackgroundHoverDark,
    ColorBackgroundHoverDarkHc: ColorBackgroundHoverDarkHc,
    ColorBackgroundPressedLight: ColorBackgroundPressedLight,
    ColorBackgroundPressedLightHc: ColorBackgroundPressedLightHc,
    ColorBackgroundPressedDark: ColorBackgroundPressedDark,
    ColorBackgroundPressedDarkHc: ColorBackgroundPressedDarkHc,
    ColorBackgroundSelectedLight: ColorBackgroundSelectedLight,
    ColorBackgroundSelectedLightHc: ColorBackgroundSelectedLightHc,
    ColorBackgroundSelectedDark: ColorBackgroundSelectedDark,
    ColorBackgroundSelectedDarkHc: ColorBackgroundSelectedDarkHc,
    ColorSelectionIndicatorLight: ColorSelectionIndicatorLight,
    ColorSelectionIndicatorLightHc: ColorSelectionIndicatorLightHc,
    ColorSelectionIndicatorDark: ColorSelectionIndicatorDark,
    ColorSelectionIndicatorDarkHc: ColorSelectionIndicatorDarkHc,
    ColorNotificationBadgeLight: ColorNotificationBadgeLight,
    ColorNotificationBadgeLightHc: ColorNotificationBadgeLightHc,
    ColorNotificationBadgeDark: ColorNotificationBadgeDark,
    ColorNotificationBadgeDarkHc: ColorNotificationBadgeDarkHc,
    ColorNotificationIndicatorLight: ColorNotificationIndicatorLight,
    ColorNotificationIndicatorLightHc: ColorNotificationIndicatorLightHc,
    ColorNotificationIndicatorDark: ColorNotificationIndicatorDark,
    ColorNotificationIndicatorDarkHc: ColorNotificationIndicatorDarkHc,
    ColorHoverLight: ColorHoverLight,
    ColorHoverLightHc: ColorHoverLightHc,
    ColorHoverDark: ColorHoverDark,
    ColorHoverDarkHc: ColorHoverDarkHc,
    ColorCurtainLight: ColorCurtainLight,
    ColorCurtainLightHc: ColorCurtainLightHc,
    ColorCurtainDark: ColorCurtainDark,
    ColorCurtainDarkHc: ColorCurtainDarkHc,
    ColorBorderLight: ColorBorderLight,
    ColorBorderLightHc: ColorBorderLightHc,
    ColorBorderDark: ColorBorderDark,
    ColorBorderDarkHc: ColorBorderDarkHc,
    ColorBorderDisabledLight: ColorBorderDisabledLight,
    ColorBorderDisabledLightHc: ColorBorderDisabledLightHc,
    ColorBorderDisabledDark: ColorBorderDisabledDark,
    ColorBorderDisabledDarkHc: ColorBorderDisabledDarkHc,
    ColorBorderGridLight: ColorBorderGridLight,
    ColorBorderGridLightHc: ColorBorderGridLightHc,
    ColorBorderGridDark: ColorBorderGridDark,
    ColorBorderGridDarkHc: ColorBorderGridDarkHc,
    ColorBorderDeEmpLight: ColorBorderDeEmpLight,
    ColorBorderDeEmpLightHc: ColorBorderDeEmpLightHc,
    ColorBorderDeEmpDark: ColorBorderDeEmpDark,
    ColorBorderDeEmpDarkHc: ColorBorderDeEmpDarkHc,
    ColorSelectionLight: ColorSelectionLight,
    ColorSelectionLightHc: ColorSelectionLightHc,
    ColorSelectionDark: ColorSelectionDark,
    ColorSelectionDarkHc: ColorSelectionDarkHc,
    ColorLogoLight: ColorLogoLight,
    ColorLogoLightHc: ColorLogoLightHc,
    ColorLogoDark: ColorLogoDark,
    ColorLogoDarkHc: ColorLogoDarkHc,
    ColorForegroundLight: ColorForegroundLight,
    ColorForegroundLightHc: ColorForegroundLightHc,
    ColorForegroundDark: ColorForegroundDark,
    ColorForegroundDarkHc: ColorForegroundDarkHc,
    ColorForegroundLightLight: ColorForegroundLightLight,
    ColorForegroundLightLightHc: ColorForegroundLightLightHc,
    ColorForegroundLightDark: ColorForegroundLightDark,
    ColorForegroundLightDarkHc: ColorForegroundLightDarkHc,
    ColorForegroundEmpLight: ColorForegroundEmpLight,
    ColorForegroundEmpLightHc: ColorForegroundEmpLightHc,
    ColorForegroundEmpDark: ColorForegroundEmpDark,
    ColorForegroundEmpDarkHc: ColorForegroundEmpDarkHc,
    ColorForegroundDeEmpLight: ColorForegroundDeEmpLight,
    ColorForegroundDeEmpLightHc: ColorForegroundDeEmpLightHc,
    ColorForegroundDeEmpDark: ColorForegroundDeEmpDark,
    ColorForegroundDeEmpDarkHc: ColorForegroundDeEmpDarkHc,
    ColorForegroundDisableLight: ColorForegroundDisableLight,
    ColorForegroundDisableLightHc: ColorForegroundDisableLightHc,
    ColorForegroundDisableDark: ColorForegroundDisableDark,
    ColorForegroundDisableDarkHc: ColorForegroundDisableDarkHc,
    ColorForegroundInverseLight: ColorForegroundInverseLight,
    ColorForegroundInverseLightHc: ColorForegroundInverseLightHc,
    ColorForegroundInverseDark: ColorForegroundInverseDark,
    ColorForegroundInverseDarkHc: ColorForegroundInverseDarkHc,
    ColorForegroundHighlightLight: ColorForegroundHighlightLight,
    ColorForegroundHighlightLightHc: ColorForegroundHighlightLightHc,
    ColorForegroundHighlightDark: ColorForegroundHighlightDark,
    ColorForegroundHighlightDarkHc: ColorForegroundHighlightDarkHc,
    ColorForegroundHighlightSelectedLight: ColorForegroundHighlightSelectedLight,
    ColorForegroundHighlightSelectedLightHc: ColorForegroundHighlightSelectedLightHc,
    ColorForegroundHighlightSelectedDark: ColorForegroundHighlightSelectedDark,
    ColorForegroundHighlightSelectedDarkHc: ColorForegroundHighlightSelectedDarkHc,
    ColorForegroundHighlightSelectedHoverLight: ColorForegroundHighlightSelectedHoverLight,
    ColorForegroundHighlightSelectedHoverLightHc: ColorForegroundHighlightSelectedHoverLightHc,
    ColorForegroundHighlightSelectedHoverDark: ColorForegroundHighlightSelectedHoverDark,
    ColorForegroundHighlightSelectedHoverDarkHc: ColorForegroundHighlightSelectedHoverDarkHc,
    ColorForegroundLinkLight: ColorForegroundLinkLight,
    ColorForegroundLinkLightHc: ColorForegroundLinkLightHc,
    ColorForegroundLinkDark: ColorForegroundLinkDark,
    ColorForegroundLinkDarkHc: ColorForegroundLinkDarkHc,
    ColorForegroundLinkPressedLight: ColorForegroundLinkPressedLight,
    ColorForegroundLinkPressedLightHc: ColorForegroundLinkPressedLightHc,
    ColorForegroundLinkPressedDark: ColorForegroundLinkPressedDark,
    ColorForegroundLinkPressedDarkHc: ColorForegroundLinkPressedDarkHc,
    ColorForegroundInvDeEmpLight: ColorForegroundInvDeEmpLight,
    ColorForegroundInvDeEmpLightHc: ColorForegroundInvDeEmpLightHc,
    ColorForegroundInvDeEmpDark: ColorForegroundInvDeEmpDark,
    ColorForegroundInvDeEmpDarkHc: ColorForegroundInvDeEmpDarkHc,
    ColorPrimaryLight: ColorPrimaryLight,
    ColorPrimaryLightHc: ColorPrimaryLightHc,
    ColorPrimaryDark: ColorPrimaryDark,
    ColorPrimaryDarkHc: ColorPrimaryDarkHc,
    ColorPrimaryLighterLight: ColorPrimaryLighterLight,
    ColorPrimaryLighterLightHc: ColorPrimaryLighterLightHc,
    ColorPrimaryLighterDark: ColorPrimaryLighterDark,
    ColorPrimaryLighterDarkHc: ColorPrimaryLighterDarkHc,
    ColorPrimaryDarkerLight: ColorPrimaryDarkerLight,
    ColorPrimaryDarkerLightHc: ColorPrimaryDarkerLightHc,
    ColorPrimaryDarkerDark: ColorPrimaryDarkerDark,
    ColorPrimaryDarkerDarkHc: ColorPrimaryDarkerDarkHc,
    ColorPrimaryHoverLight: ColorPrimaryHoverLight,
    ColorPrimaryHoverLightHc: ColorPrimaryHoverLightHc,
    ColorPrimaryHoverDark: ColorPrimaryHoverDark,
    ColorPrimaryHoverDarkHc: ColorPrimaryHoverDarkHc,
    ColorPrimaryFocusedLight: ColorPrimaryFocusedLight,
    ColorPrimaryFocusedLightHc: ColorPrimaryFocusedLightHc,
    ColorPrimaryFocusedDark: ColorPrimaryFocusedDark,
    ColorPrimaryFocusedDarkHc: ColorPrimaryFocusedDarkHc,
    ColorPrimaryPressedLight: ColorPrimaryPressedLight,
    ColorPrimaryPressedLightHc: ColorPrimaryPressedLightHc,
    ColorPrimaryPressedDark: ColorPrimaryPressedDark,
    ColorPrimaryPressedDarkHc: ColorPrimaryPressedDarkHc,
    ColorSecondaryFocusedLight: ColorSecondaryFocusedLight,
    ColorSecondaryFocusedLightHc: ColorSecondaryFocusedLightHc,
    ColorSecondaryFocusedDark: ColorSecondaryFocusedDark,
    ColorSecondaryFocusedDarkHc: ColorSecondaryFocusedDarkHc,
    ColorSecondaryPressedLight: ColorSecondaryPressedLight,
    ColorSecondaryPressedLightHc: ColorSecondaryPressedLightHc,
    ColorSecondaryPressedDark: ColorSecondaryPressedDark,
    ColorSecondaryPressedDarkHc: ColorSecondaryPressedDarkHc,
    ColorChipDefaultBackgroundLight: ColorChipDefaultBackgroundLight,
    ColorChipDefaultBackgroundLightHc: ColorChipDefaultBackgroundLightHc,
    ColorChipDefaultBackgroundDark: ColorChipDefaultBackgroundDark,
    ColorChipDefaultBackgroundDarkHc: ColorChipDefaultBackgroundDarkHc,
    ColorChipErrorBackgroundLight: ColorChipErrorBackgroundLight,
    ColorChipErrorBackgroundLightHc: ColorChipErrorBackgroundLightHc,
    ColorChipErrorBackgroundDark: ColorChipErrorBackgroundDark,
    ColorChipErrorBackgroundDarkHc: ColorChipErrorBackgroundDarkHc,
    ColorChipWarningBackgroundLight: ColorChipWarningBackgroundLight,
    ColorChipWarningBackgroundLightHc: ColorChipWarningBackgroundLightHc,
    ColorChipWarningBackgroundDark: ColorChipWarningBackgroundDark,
    ColorChipWarningBackgroundDarkHc: ColorChipWarningBackgroundDarkHc,
    ColorChipInfoBackgroundLight: ColorChipInfoBackgroundLight,
    ColorChipInfoBackgroundLightHc: ColorChipInfoBackgroundLightHc,
    ColorChipInfoBackgroundDark: ColorChipInfoBackgroundDark,
    ColorChipInfoBackgroundDarkHc: ColorChipInfoBackgroundDarkHc,
    ColorChipSuccessBackgroundLight: ColorChipSuccessBackgroundLight,
    ColorChipSuccessBackgroundLightHc: ColorChipSuccessBackgroundLightHc,
    ColorChipSuccessBackgroundDark: ColorChipSuccessBackgroundDark,
    ColorChipSuccessBackgroundDarkHc: ColorChipSuccessBackgroundDarkHc,
    ColorErrorIconLight: ColorErrorIconLight,
    ColorErrorIconLightHc: ColorErrorIconLightHc,
    ColorErrorIconDark: ColorErrorIconDark,
    ColorErrorIconDarkHc: ColorErrorIconDarkHc,
    ColorErrorIconInverseLight: ColorErrorIconInverseLight,
    ColorErrorIconInverseLightHc: ColorErrorIconInverseLightHc,
    ColorErrorIconInverseDark: ColorErrorIconInverseDark,
    ColorErrorIconInverseDarkHc: ColorErrorIconInverseDarkHc,
    ColorErrorTextLight: ColorErrorTextLight,
    ColorErrorTextLightHc: ColorErrorTextLightHc,
    ColorErrorTextDark: ColorErrorTextDark,
    ColorErrorTextDarkHc: ColorErrorTextDarkHc,
    ColorErrorBackgroundLight: ColorErrorBackgroundLight,
    ColorErrorBackgroundLightHc: ColorErrorBackgroundLightHc,
    ColorErrorBackgroundDark: ColorErrorBackgroundDark,
    ColorErrorBackgroundDarkHc: ColorErrorBackgroundDarkHc,
    ColorErrorForegroundInverseLight: ColorErrorForegroundInverseLight,
    ColorErrorForegroundInverseLightHc: ColorErrorForegroundInverseLightHc,
    ColorErrorForegroundInverseDark: ColorErrorForegroundInverseDark,
    ColorErrorForegroundInverseDarkHc: ColorErrorForegroundInverseDarkHc,
    ColorInfoForegroundLight: ColorInfoForegroundLight,
    ColorInfoForegroundLightHc: ColorInfoForegroundLightHc,
    ColorInfoForegroundDark: ColorInfoForegroundDark,
    ColorInfoForegroundDarkHc: ColorInfoForegroundDarkHc,
    ColorInfoIconLight: ColorInfoIconLight,
    ColorInfoIconLightHc: ColorInfoIconLightHc,
    ColorInfoIconDark: ColorInfoIconDark,
    ColorInfoIconDarkHc: ColorInfoIconDarkHc,
    ColorInfoIconInverseLight: ColorInfoIconInverseLight,
    ColorInfoIconInverseLightHc: ColorInfoIconInverseLightHc,
    ColorInfoIconInverseDark: ColorInfoIconInverseDark,
    ColorInfoIconInverseDarkHc: ColorInfoIconInverseDarkHc,
    ColorInfoTextLight: ColorInfoTextLight,
    ColorInfoTextLightHc: ColorInfoTextLightHc,
    ColorInfoTextDark: ColorInfoTextDark,
    ColorInfoTextDarkHc: ColorInfoTextDarkHc,
    ColorInfoForegroundInverseLight: ColorInfoForegroundInverseLight,
    ColorInfoForegroundInverseLightHc: ColorInfoForegroundInverseLightHc,
    ColorInfoForegroundInverseDark: ColorInfoForegroundInverseDark,
    ColorInfoForegroundInverseDarkHc: ColorInfoForegroundInverseDarkHc,
    ColorInfoBackgroundLight: ColorInfoBackgroundLight,
    ColorInfoBackgroundLightHc: ColorInfoBackgroundLightHc,
    ColorInfoBackgroundDark: ColorInfoBackgroundDark,
    ColorInfoBackgroundDarkHc: ColorInfoBackgroundDarkHc,
    ColorSuccessIconLight: ColorSuccessIconLight,
    ColorSuccessIconLightHc: ColorSuccessIconLightHc,
    ColorSuccessIconDark: ColorSuccessIconDark,
    ColorSuccessIconDarkHc: ColorSuccessIconDarkHc,
    ColorSuccessIconInverseLight: ColorSuccessIconInverseLight,
    ColorSuccessIconInverseLightHc: ColorSuccessIconInverseLightHc,
    ColorSuccessIconInverseDark: ColorSuccessIconInverseDark,
    ColorSuccessIconInverseDarkHc: ColorSuccessIconInverseDarkHc,
    ColorSuccessTextLight: ColorSuccessTextLight,
    ColorSuccessTextLightHc: ColorSuccessTextLightHc,
    ColorSuccessTextDark: ColorSuccessTextDark,
    ColorSuccessTextDarkHc: ColorSuccessTextDarkHc,
    ColorSuccessBackgroundLight: ColorSuccessBackgroundLight,
    ColorSuccessBackgroundLightHc: ColorSuccessBackgroundLightHc,
    ColorSuccessBackgroundDark: ColorSuccessBackgroundDark,
    ColorSuccessBackgroundDarkHc: ColorSuccessBackgroundDarkHc,
    ColorSuccessForegroundInverseLight: ColorSuccessForegroundInverseLight,
    ColorSuccessForegroundInverseLightHc: ColorSuccessForegroundInverseLightHc,
    ColorSuccessForegroundInverseDark: ColorSuccessForegroundInverseDark,
    ColorSuccessForegroundInverseDarkHc: ColorSuccessForegroundInverseDarkHc,
    ColorWarningIconLight: ColorWarningIconLight,
    ColorWarningIconLightHc: ColorWarningIconLightHc,
    ColorWarningIconDark: ColorWarningIconDark,
    ColorWarningIconDarkHc: ColorWarningIconDarkHc,
    ColorWarningIconInverseLight: ColorWarningIconInverseLight,
    ColorWarningIconInverseLightHc: ColorWarningIconInverseLightHc,
    ColorWarningIconInverseDark: ColorWarningIconInverseDark,
    ColorWarningIconInverseDarkHc: ColorWarningIconInverseDarkHc,
    ColorWarningTextLight: ColorWarningTextLight,
    ColorWarningTextLightHc: ColorWarningTextLightHc,
    ColorWarningTextDark: ColorWarningTextDark,
    ColorWarningTextDarkHc: ColorWarningTextDarkHc,
    ColorWarningBackgroundLight: ColorWarningBackgroundLight,
    ColorWarningBackgroundLightHc: ColorWarningBackgroundLightHc,
    ColorWarningBackgroundDark: ColorWarningBackgroundDark,
    ColorWarningBackgroundDarkHc: ColorWarningBackgroundDarkHc,
    ColorWarningForegroundInverseLight: ColorWarningForegroundInverseLight,
    ColorWarningForegroundInverseLightHc: ColorWarningForegroundInverseLightHc,
    ColorWarningForegroundInverseDark: ColorWarningForegroundInverseDark,
    ColorWarningForegroundInverseDarkHc: ColorWarningForegroundInverseDarkHc,
    ColorIconDefaultLight: ColorIconDefaultLight,
    ColorIconDefaultLightHc: ColorIconDefaultLightHc,
    ColorIconDefaultDark: ColorIconDefaultDark,
    ColorIconDefaultDarkHc: ColorIconDefaultDarkHc,
    ColorIconInvertedDefaultLight: ColorIconInvertedDefaultLight,
    ColorIconInvertedDefaultLightHc: ColorIconInvertedDefaultLightHc,
    ColorIconInvertedDefaultDark: ColorIconInvertedDefaultDark,
    ColorIconInvertedDefaultDarkHc: ColorIconInvertedDefaultDarkHc,
    ColorToggleOffHoverLight: ColorToggleOffHoverLight,
    ColorToggleOffHoverLightHc: ColorToggleOffHoverLightHc,
    ColorToggleOffHoverDark: ColorToggleOffHoverDark,
    ColorToggleOffHoverDarkHc: ColorToggleOffHoverDarkHc,
    ColorToggleOffFocusLight: ColorToggleOffFocusLight,
    ColorToggleOffFocusLightHc: ColorToggleOffFocusLightHc,
    ColorToggleOffFocusDark: ColorToggleOffFocusDark,
    ColorToggleOffFocusDarkHc: ColorToggleOffFocusDarkHc,
    ColorToggleOffPressedLight: ColorToggleOffPressedLight,
    ColorToggleOffPressedLightHc: ColorToggleOffPressedLightHc,
    ColorToggleOffPressedDark: ColorToggleOffPressedDark,
    ColorToggleOffPressedDarkHc: ColorToggleOffPressedDarkHc,
    ColorToggleOnHoverLight: ColorToggleOnHoverLight,
    ColorToggleOnHoverLightHc: ColorToggleOnHoverLightHc,
    ColorToggleOnHoverDark: ColorToggleOnHoverDark,
    ColorToggleOnHoverDarkHc: ColorToggleOnHoverDarkHc,
    ColorToggleOnFocusLight: ColorToggleOnFocusLight,
    ColorToggleOnFocusLightHc: ColorToggleOnFocusLightHc,
    ColorToggleOnFocusDark: ColorToggleOnFocusDark,
    ColorToggleOnFocusDarkHc: ColorToggleOnFocusDarkHc,
    ColorToggleOnPressedLight: ColorToggleOnPressedLight,
    ColorToggleOnPressedLightHc: ColorToggleOnPressedLightHc,
    ColorToggleOnPressedDark: ColorToggleOnPressedDark,
    ColorToggleOnPressedDarkHc: ColorToggleOnPressedDarkHc,
    ColorCalloutBackgroundLight: ColorCalloutBackgroundLight,
    ColorCalloutBackgroundLightHc: ColorCalloutBackgroundLightHc,
    ColorCalloutBackgroundDark: ColorCalloutBackgroundDark,
    ColorCalloutBackgroundDarkHc: ColorCalloutBackgroundDarkHc,
    ColorWarnLight: ColorWarnLight,
    ColorWarnLightHc: ColorWarnLightHc,
    ColorWarnDark: ColorWarnDark,
    ColorWarnDarkHc: ColorWarnDarkHc,
    ColorWarnDarkerLight: ColorWarnDarkerLight,
    ColorWarnDarkerLightHc: ColorWarnDarkerLightHc,
    ColorWarnDarkerDark: ColorWarnDarkerDark,
    ColorWarnDarkerDarkHc: ColorWarnDarkerDarkHc,
    ColorWarnHoverLight: ColorWarnHoverLight,
    ColorWarnHoverLightHc: ColorWarnHoverLightHc,
    ColorWarnHoverDark: ColorWarnHoverDark,
    ColorWarnHoverDarkHc: ColorWarnHoverDarkHc,
    ColorWarnFocusLight: ColorWarnFocusLight,
    ColorWarnFocusLightHc: ColorWarnFocusLightHc,
    ColorWarnFocusDark: ColorWarnFocusDark,
    ColorWarnFocusDarkHc: ColorWarnFocusDarkHc,
    ColorWarnPressedLight: ColorWarnPressedLight,
    ColorWarnPressedLightHc: ColorWarnPressedLightHc,
    ColorWarnPressedDark: ColorWarnPressedDark,
    ColorWarnPressedDarkHc: ColorWarnPressedDarkHc,
    ColorCarouselBackgroundLight: ColorCarouselBackgroundLight,
    ColorCarouselBackgroundLightHc: ColorCarouselBackgroundLightHc,
    ColorCarouselBackgroundDark: ColorCarouselBackgroundDark,
    ColorCarouselBackgroundDarkHc: ColorCarouselBackgroundDarkHc,
    ColorIconButtonHoverLight: ColorIconButtonHoverLight,
    ColorIconButtonHoverLightHc: ColorIconButtonHoverLightHc,
    ColorIconButtonHoverDark: ColorIconButtonHoverDark,
    ColorIconButtonHoverDarkHc: ColorIconButtonHoverDarkHc,
    ColorIconButtonFocusLight: ColorIconButtonFocusLight,
    ColorIconButtonFocusLightHc: ColorIconButtonFocusLightHc,
    ColorIconButtonFocusDark: ColorIconButtonFocusDark,
    ColorIconButtonFocusDarkHc: ColorIconButtonFocusDarkHc,
    ColorIconButtonPressedLight: ColorIconButtonPressedLight,
    ColorIconButtonPressedLightHc: ColorIconButtonPressedLightHc,
    ColorIconButtonPressedDark: ColorIconButtonPressedDark,
    ColorIconButtonPressedDarkHc: ColorIconButtonPressedDarkHc,
    ColorCodeFunctionLight: ColorCodeFunctionLight,
    ColorCodeFunctionLightHc: ColorCodeFunctionLightHc,
    ColorCodeFunctionDark: ColorCodeFunctionDark,
    ColorCodeFunctionDarkHc: ColorCodeFunctionDarkHc,
    ColorCodeOperatorLight: ColorCodeOperatorLight,
    ColorCodeOperatorLightHc: ColorCodeOperatorLightHc,
    ColorCodeOperatorDark: ColorCodeOperatorDark,
    ColorCodeOperatorDarkHc: ColorCodeOperatorDarkHc,
    ColorCodeNumericLight: ColorCodeNumericLight,
    ColorCodeNumericLightHc: ColorCodeNumericLightHc,
    ColorCodeNumericDark: ColorCodeNumericDark,
    ColorCodeNumericDarkHc: ColorCodeNumericDarkHc,
    ColorCodeTextLight: ColorCodeTextLight,
    ColorCodeTextLightHc: ColorCodeTextLightHc,
    ColorCodeTextDark: ColorCodeTextDark,
    ColorCodeTextDarkHc: ColorCodeTextDarkHc,
    ColorToggleThumbOffLight: ColorToggleThumbOffLight,
    ColorToggleThumbOffLightHc: ColorToggleThumbOffLightHc,
    ColorToggleThumbOffDark: ColorToggleThumbOffDark,
    ColorToggleThumbOffDarkHc: ColorToggleThumbOffDarkHc,
    ColorToggleTrackOffLight: ColorToggleTrackOffLight,
    ColorToggleTrackOffLightHc: ColorToggleTrackOffLightHc,
    ColorToggleTrackOffDark: ColorToggleTrackOffDark,
    ColorToggleTrackOffDarkHc: ColorToggleTrackOffDarkHc,
    ColorToggleThumbOnLight: ColorToggleThumbOnLight,
    ColorToggleThumbOnLightHc: ColorToggleThumbOnLightHc,
    ColorToggleThumbOnDark: ColorToggleThumbOnDark,
    ColorToggleThumbOnDarkHc: ColorToggleThumbOnDarkHc,
    ColorToggleTrackOnLight: ColorToggleTrackOnLight,
    ColorToggleTrackOnLightHc: ColorToggleTrackOnLightHc,
    ColorToggleTrackOnDark: ColorToggleTrackOnDark,
    ColorToggleTrackOnDarkHc: ColorToggleTrackOnDarkHc,
    ColorToggleThumbOffDisabledLight: ColorToggleThumbOffDisabledLight,
    ColorToggleThumbOffDisabledLightHc: ColorToggleThumbOffDisabledLightHc,
    ColorToggleThumbOffDisabledDark: ColorToggleThumbOffDisabledDark,
    ColorToggleThumbOffDisabledDarkHc: ColorToggleThumbOffDisabledDarkHc,
    ColorToggleTrackOffDisabledLight: ColorToggleTrackOffDisabledLight,
    ColorToggleTrackOffDisabledLightHc: ColorToggleTrackOffDisabledLightHc,
    ColorToggleTrackOffDisabledDark: ColorToggleTrackOffDisabledDark,
    ColorToggleTrackOffDisabledDarkHc: ColorToggleTrackOffDisabledDarkHc,
    ColorToggleThumbOnDisabledLight: ColorToggleThumbOnDisabledLight,
    ColorToggleThumbOnDisabledLightHc: ColorToggleThumbOnDisabledLightHc,
    ColorToggleThumbOnDisabledDark: ColorToggleThumbOnDisabledDark,
    ColorToggleThumbOnDisabledDarkHc: ColorToggleThumbOnDisabledDarkHc,
    ColorToggleTrackOnDisabledLight: ColorToggleTrackOnDisabledLight,
    ColorToggleTrackOnDisabledLightHc: ColorToggleTrackOnDisabledLightHc,
    ColorToggleTrackOnDisabledDark: ColorToggleTrackOnDisabledDark,
    ColorToggleTrackOnDisabledDarkHc: ColorToggleTrackOnDisabledDarkHc,
    ColorSkeletonLight: ColorSkeletonLight,
    ColorSkeletonLightHc: ColorSkeletonLightHc,
    ColorSkeletonDark: ColorSkeletonDark,
    ColorSkeletonDarkHc: ColorSkeletonDarkHc,
    ColorSkeletonGlowLight: ColorSkeletonGlowLight,
    ColorSkeletonGlowLightHc: ColorSkeletonGlowLightHc,
    ColorSkeletonGlowDark: ColorSkeletonGlowDark,
    ColorSkeletonGlowDarkHc: ColorSkeletonGlowDarkHc,
    ColorDataGridHoverLight: ColorDataGridHoverLight,
    ColorDataGridHoverLightHc: ColorDataGridHoverLightHc,
    ColorDataGridHoverDark: ColorDataGridHoverDark,
    ColorDataGridHoverDarkHc: ColorDataGridHoverDarkHc,
    ColorDataGridPressedLight: ColorDataGridPressedLight,
    ColorDataGridPressedLightHc: ColorDataGridPressedLightHc,
    ColorDataGridPressedDark: ColorDataGridPressedDark,
    ColorDataGridPressedDarkHc: ColorDataGridPressedDarkHc,
    ColorFocusIndicatorLight: ColorFocusIndicatorLight,
    ColorFocusIndicatorLightHc: ColorFocusIndicatorLightHc,
    ColorFocusIndicatorDark: ColorFocusIndicatorDark,
    ColorFocusIndicatorDarkHc: ColorFocusIndicatorDarkHc,
    ColorFocusIndicatorInverseLight: ColorFocusIndicatorInverseLight,
    ColorFocusIndicatorInverseLightHc: ColorFocusIndicatorInverseLightHc,
    ColorFocusIndicatorInverseDark: ColorFocusIndicatorInverseDark,
    ColorFocusIndicatorInverseDarkHc: ColorFocusIndicatorInverseDarkHc,
    ColorChartPurpleLight: ColorChartPurpleLight,
    ColorChartPurpleLightHc: ColorChartPurpleLightHc,
    ColorChartPurpleDark: ColorChartPurpleDark,
    ColorChartPurpleDarkHc: ColorChartPurpleDarkHc,
    ColorChartPinkLight: ColorChartPinkLight,
    ColorChartPinkLightHc: ColorChartPinkLightHc,
    ColorChartPinkDark: ColorChartPinkDark,
    ColorChartPinkDarkHc: ColorChartPinkDarkHc,
    ColorChartBlueSecondaryLight: ColorChartBlueSecondaryLight,
    ColorChartBlueSecondaryLightHc: ColorChartBlueSecondaryLightHc,
    ColorChartBlueSecondaryDark: ColorChartBlueSecondaryDark,
    ColorChartBlueSecondaryDarkHc: ColorChartBlueSecondaryDarkHc,
    ColorChartLightBlueLight: ColorChartLightBlueLight,
    ColorChartLightBlueLightHc: ColorChartLightBlueLightHc,
    ColorChartLightBlueDark: ColorChartLightBlueDark,
    ColorChartLightBlueDarkHc: ColorChartLightBlueDarkHc,
    ColorChartGreenLight: ColorChartGreenLight,
    ColorChartGreenLightHc: ColorChartGreenLightHc,
    ColorChartGreenDark: ColorChartGreenDark,
    ColorChartGreenDarkHc: ColorChartGreenDarkHc,
    ColorChartYellowLight: ColorChartYellowLight,
    ColorChartYellowLightHc: ColorChartYellowLightHc,
    ColorChartYellowDark: ColorChartYellowDark,
    ColorChartYellowDarkHc: ColorChartYellowDarkHc
});

const FontNormal = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontTitle = "poppins, noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\", \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontMono = "inconsolata, monospace";
const FontWeightLight = 300;
const FontWeightDefault = 400;
const FontWeightMedium = 500;
const FontWeightSemibold = 600;
const FontWeightBold = 700;
const FontMicroSize = "8px";
const FontMicroLineHeight = "12px";
const FontLeftRailSize = "10px";
const FontLeftRailLineHeight = "10px";
const FontHeroBoldFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontHeroBoldSize = "60px";
const FontHeroBoldLineHeight = "72px";
const FontHeroBoldWeight = 400;
const FontHeroFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontHeroSize = "60px";
const FontHeroLineHeight = "72px";
const FontHeroWeight = 300;
const FontHeader1BoldFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif"; // h1
const FontHeader1BoldSize = "36px";
const FontHeader1BoldLineHeight = "44px";
const FontHeader1BoldWeight = 400;
const FontHeader1Family = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif"; // h1
const FontHeader1Size = "36px";
const FontHeader1LineHeight = "44px";
const FontHeader1Weight = 300;
const FontHeader2BoldFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif"; // h2
const FontHeader2BoldSize = "32px";
const FontHeader2BoldLineHeight = "40px";
const FontHeader2BoldWeight = 400;
const FontHeader2Family = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif"; // h2
const FontHeader2Size = "32px";
const FontHeader2LineHeight = "40px";
const FontHeader2Weight = 300;
const FontHeader3BoldFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif"; // h3
const FontHeader3BoldSize = "24px";
const FontHeader3BoldLineHeight = "32px";
const FontHeader3BoldWeight = 700;
const FontHeader3Family = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif"; // h3
const FontHeader3Size = "24px";
const FontHeader3LineHeight = "24px";
const FontHeader3Weight = 400;
const FontHeader4BoldFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif"; // h4
const FontHeader4BoldSize = "20px";
const FontHeader4BoldLineHeight = "24px";
const FontHeader4BoldWeight = 600;
const FontHeader4Family = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif"; // h4
const FontHeader4Size = "20px";
const FontHeader4LineHeight = "24px";
const FontHeader4Weight = 400;
const FontLBoldFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontLBoldSize = "16px";
const FontLBoldLineHeight = "24px";
const FontLBoldWeight = 600;
const FontLFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontLSize = "16px";
const FontLLineHeight = "24px";
const FontLWeight = 400;
const FontMBoldFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontMBoldSize = "14px";
const FontMBoldLineHeight = "20px";
const FontMBoldWeight = 600;
const FontMFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontMSize = "14px";
const FontMLineHeight = "20px";
const FontMWeight = 400;
const FontLinkFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontLinkSize = "14px";
const FontLinkLineHeight = "20px";
const FontLinkWeight = 600;
const FontSBoldFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontSBoldSize = "12px";
const FontSBoldLineHeight = "16px";
const FontSBoldWeight = 600;
const FontSFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontSSize = "12px";
const FontSLineHeight = "16px";
const FontSWeight = 400;
const FontXsBoldFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontXsBoldSize = "10px";
const FontXsBoldLineHeight = "16px";
const FontXsBoldWeight = 600;
const FontXsFamily = "noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\",  \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontXsSize = "10px";
const FontXsLineHeight = "16px";
const FontXsWeight = 400;
const FontBrandH4Family = "poppins, noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\", \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif"; // h4
const FontBrandH4Size = "20px";
const FontBrandH4LineHeight = "24px";
const FontBrandH4LetterSpacing = "-0.528px";
const FontBrandH4Weight = 600;
const FontBrandLFamily = "poppins, noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\", \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontBrandLSize = "16px";
const FontBrandLLineHeight = "24px";
const FontBrandLWeight = 600;
const FontBrandMFamily = "poppins, noto-sans, \"Noto Sans JP\", \"Noto Sans KR\", \"Noto Sans SC\", \"Noto Sans TC\", \"Noto Sans\", -apple-system, system-ui, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial,sans-serif";
const FontBrandMSize = "14px";
const FontBrandMLineHeight = "24px";
const FontBrandMWeight = 500;
const FontMonoMBoldFamily = "inconsolata, monospace";
const FontMonoMBoldSize = "14px";
const FontMonoMBoldLineHeight = "20px";
const FontMonoMBoldWeight = 700;
const FontMonoMFamily = "inconsolata, monospace";
const FontMonoMSize = "14px";
const FontMonoMLineHeight = "20px";
const FontMonoMWeight = 400;
const FontMonoSBoldFamily = "inconsolata, monospace";
const FontMonoSBoldSize = "12px";
const FontMonoSBoldLineHeight = "16px";
const FontMonoSBoldWeight = 700;
const FontMonoSFamily = "inconsolata, monospace";
const FontMonoSSize = "12px";
const FontMonoSLineHeight = "16px";
const FontMonoSWeight = 400;
const FontMonoXsBoldFamily = "inconsolata, monospace";
const FontMonoXsBoldSize = "10px";
const FontMonoXsBoldLineHeight = "16px";
const FontMonoXsBoldWeight = 700;
const FontMonoXsFamily = "inconsolata, monospace";
const FontMonoXsSize = "10px";
const FontMonoXsLineHeight = "16px";
const FontMonoXsWeight = 400;

const FontFamily = /*#__PURE__*/Object.freeze({
    __proto__: null,
    FontNormal: FontNormal,
    FontTitle: FontTitle,
    FontMono: FontMono,
    FontWeightLight: FontWeightLight,
    FontWeightDefault: FontWeightDefault,
    FontWeightMedium: FontWeightMedium,
    FontWeightSemibold: FontWeightSemibold,
    FontWeightBold: FontWeightBold,
    FontMicroSize: FontMicroSize,
    FontMicroLineHeight: FontMicroLineHeight,
    FontLeftRailSize: FontLeftRailSize,
    FontLeftRailLineHeight: FontLeftRailLineHeight,
    FontHeroBoldFamily: FontHeroBoldFamily,
    FontHeroBoldSize: FontHeroBoldSize,
    FontHeroBoldLineHeight: FontHeroBoldLineHeight,
    FontHeroBoldWeight: FontHeroBoldWeight,
    FontHeroFamily: FontHeroFamily,
    FontHeroSize: FontHeroSize,
    FontHeroLineHeight: FontHeroLineHeight,
    FontHeroWeight: FontHeroWeight,
    FontHeader1BoldFamily: FontHeader1BoldFamily,
    FontHeader1BoldSize: FontHeader1BoldSize,
    FontHeader1BoldLineHeight: FontHeader1BoldLineHeight,
    FontHeader1BoldWeight: FontHeader1BoldWeight,
    FontHeader1Family: FontHeader1Family,
    FontHeader1Size: FontHeader1Size,
    FontHeader1LineHeight: FontHeader1LineHeight,
    FontHeader1Weight: FontHeader1Weight,
    FontHeader2BoldFamily: FontHeader2BoldFamily,
    FontHeader2BoldSize: FontHeader2BoldSize,
    FontHeader2BoldLineHeight: FontHeader2BoldLineHeight,
    FontHeader2BoldWeight: FontHeader2BoldWeight,
    FontHeader2Family: FontHeader2Family,
    FontHeader2Size: FontHeader2Size,
    FontHeader2LineHeight: FontHeader2LineHeight,
    FontHeader2Weight: FontHeader2Weight,
    FontHeader3BoldFamily: FontHeader3BoldFamily,
    FontHeader3BoldSize: FontHeader3BoldSize,
    FontHeader3BoldLineHeight: FontHeader3BoldLineHeight,
    FontHeader3BoldWeight: FontHeader3BoldWeight,
    FontHeader3Family: FontHeader3Family,
    FontHeader3Size: FontHeader3Size,
    FontHeader3LineHeight: FontHeader3LineHeight,
    FontHeader3Weight: FontHeader3Weight,
    FontHeader4BoldFamily: FontHeader4BoldFamily,
    FontHeader4BoldSize: FontHeader4BoldSize,
    FontHeader4BoldLineHeight: FontHeader4BoldLineHeight,
    FontHeader4BoldWeight: FontHeader4BoldWeight,
    FontHeader4Family: FontHeader4Family,
    FontHeader4Size: FontHeader4Size,
    FontHeader4LineHeight: FontHeader4LineHeight,
    FontHeader4Weight: FontHeader4Weight,
    FontLBoldFamily: FontLBoldFamily,
    FontLBoldSize: FontLBoldSize,
    FontLBoldLineHeight: FontLBoldLineHeight,
    FontLBoldWeight: FontLBoldWeight,
    FontLFamily: FontLFamily,
    FontLSize: FontLSize,
    FontLLineHeight: FontLLineHeight,
    FontLWeight: FontLWeight,
    FontMBoldFamily: FontMBoldFamily,
    FontMBoldSize: FontMBoldSize,
    FontMBoldLineHeight: FontMBoldLineHeight,
    FontMBoldWeight: FontMBoldWeight,
    FontMFamily: FontMFamily,
    FontMSize: FontMSize,
    FontMLineHeight: FontMLineHeight,
    FontMWeight: FontMWeight,
    FontLinkFamily: FontLinkFamily,
    FontLinkSize: FontLinkSize,
    FontLinkLineHeight: FontLinkLineHeight,
    FontLinkWeight: FontLinkWeight,
    FontSBoldFamily: FontSBoldFamily,
    FontSBoldSize: FontSBoldSize,
    FontSBoldLineHeight: FontSBoldLineHeight,
    FontSBoldWeight: FontSBoldWeight,
    FontSFamily: FontSFamily,
    FontSSize: FontSSize,
    FontSLineHeight: FontSLineHeight,
    FontSWeight: FontSWeight,
    FontXsBoldFamily: FontXsBoldFamily,
    FontXsBoldSize: FontXsBoldSize,
    FontXsBoldLineHeight: FontXsBoldLineHeight,
    FontXsBoldWeight: FontXsBoldWeight,
    FontXsFamily: FontXsFamily,
    FontXsSize: FontXsSize,
    FontXsLineHeight: FontXsLineHeight,
    FontXsWeight: FontXsWeight,
    FontBrandH4Family: FontBrandH4Family,
    FontBrandH4Size: FontBrandH4Size,
    FontBrandH4LineHeight: FontBrandH4LineHeight,
    FontBrandH4LetterSpacing: FontBrandH4LetterSpacing,
    FontBrandH4Weight: FontBrandH4Weight,
    FontBrandLFamily: FontBrandLFamily,
    FontBrandLSize: FontBrandLSize,
    FontBrandLLineHeight: FontBrandLLineHeight,
    FontBrandLWeight: FontBrandLWeight,
    FontBrandMFamily: FontBrandMFamily,
    FontBrandMSize: FontBrandMSize,
    FontBrandMLineHeight: FontBrandMLineHeight,
    FontBrandMWeight: FontBrandMWeight,
    FontMonoMBoldFamily: FontMonoMBoldFamily,
    FontMonoMBoldSize: FontMonoMBoldSize,
    FontMonoMBoldLineHeight: FontMonoMBoldLineHeight,
    FontMonoMBoldWeight: FontMonoMBoldWeight,
    FontMonoMFamily: FontMonoMFamily,
    FontMonoMSize: FontMonoMSize,
    FontMonoMLineHeight: FontMonoMLineHeight,
    FontMonoMWeight: FontMonoMWeight,
    FontMonoSBoldFamily: FontMonoSBoldFamily,
    FontMonoSBoldSize: FontMonoSBoldSize,
    FontMonoSBoldLineHeight: FontMonoSBoldLineHeight,
    FontMonoSBoldWeight: FontMonoSBoldWeight,
    FontMonoSFamily: FontMonoSFamily,
    FontMonoSSize: FontMonoSSize,
    FontMonoSLineHeight: FontMonoSLineHeight,
    FontMonoSWeight: FontMonoSWeight,
    FontMonoXsBoldFamily: FontMonoXsBoldFamily,
    FontMonoXsBoldSize: FontMonoXsBoldSize,
    FontMonoXsBoldLineHeight: FontMonoXsBoldLineHeight,
    FontMonoXsBoldWeight: FontMonoXsBoldWeight,
    FontMonoXsFamily: FontMonoXsFamily,
    FontMonoXsSize: FontMonoXsSize,
    FontMonoXsLineHeight: FontMonoXsLineHeight,
    FontMonoXsWeight: FontMonoXsWeight
});

const IconXxs = "14px";
const IconXs = "16px";
const IconS = "18px";
const IconM = "24px";
const IconL = "28px";
const IconXl = "32px";
const IconXxl = "48px";

const Icon = /*#__PURE__*/Object.freeze({
    __proto__: null,
    IconXxs: IconXxs,
    IconXs: IconXs,
    IconS: IconS,
    IconM: IconM,
    IconL: IconL,
    IconXl: IconXl,
    IconXxl: IconXxl
});

const PadXs = "2px";
const PadS = "4px";
const PadM = "6px";
const PadL = "8px";
const PadXl = "10px";
const PadXxl = "12px";
const PadXxxl = "16px";

const Padding = /*#__PURE__*/Object.freeze({
    __proto__: null,
    PadXs: PadXs,
    PadS: PadS,
    PadM: PadM,
    PadL: PadL,
    PadXl: PadXl,
    PadXxl: PadXxl,
    PadXxxl: PadXxxl
});

const ScreenSizeXsmallMin = "0px";
const ScreenSizeXsmallMax = "480px";
const ScreenSizeSmallMin = "480px";
const ScreenSizeSmallMax = "768px";
const ScreenSizeMediumMin = "768px";
const ScreenSizeMediumMax = "1024px";
const ScreenSizeLargeMin = "1024px";
const ScreenSizeLargeMax = "1280px";
const ScreenSizeXlargeMin = "1280px";
const ScreenSizeXlargeMax = "1600px";
const ScreenSizeWideMin = "1600px";
const ScreenSizeWideMax = "100000px";

const ScreenSizes = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ScreenSizeXsmallMin: ScreenSizeXsmallMin,
    ScreenSizeXsmallMax: ScreenSizeXsmallMax,
    ScreenSizeSmallMin: ScreenSizeSmallMin,
    ScreenSizeSmallMax: ScreenSizeSmallMax,
    ScreenSizeMediumMin: ScreenSizeMediumMin,
    ScreenSizeMediumMax: ScreenSizeMediumMax,
    ScreenSizeLargeMin: ScreenSizeLargeMin,
    ScreenSizeLargeMax: ScreenSizeLargeMax,
    ScreenSizeXlargeMin: ScreenSizeXlargeMin,
    ScreenSizeXlargeMax: ScreenSizeXlargeMax,
    ScreenSizeWideMin: ScreenSizeWideMin,
    ScreenSizeWideMax: ScreenSizeWideMax
});

const ShadowHighlightLight = "inset 4px 0px 0px #0067df";
const ShadowHighlightLightHc = "inset 4px 0px 0px #00489d";
const ShadowHighlightDarkHc = "inset 4px 0px 0px #dae8fa";
const ShadowHighlightDark = "inset 4px 0px 0px #66adff";
const ShadowDialogElevation = "0px 5px 10px rgba(0, 0, 0, 0.2), 0px 1px 5px rgba(0, 0, 0, 0.12), 0px 8px 10px rgba(0, 0, 0, 0.14)";
const ShadowMenuElevation = "0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.14)";
const ShadowDraggedElevation = "0px 2px 4px rgba(0, 0, 0, 0.5)";
const ShadowTooltipElevation = "0px 2px 1px -1px rgba(0, 0, 0, 0.12)";
const ShadowAltDialogElevation = "0px 24px 38px rgba(0, 0, 0, 0.14), 0px 9px 46px rgba(0, 0, 0, 0.12), 0px 11px 15px rgba(0, 0, 0, 0.2)";
const ShadowCardElevation = "0px 1px 3px rgba(0, 0, 0, 0.1)";
const ShadowDp1 = "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12)";
const ShadowDp2 = "0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)";
const ShadowDp4 = "0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)";
const ShadowDp6 = "0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12)";
const ShadowDp8 = "0px 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12)";
const ShadowDp12 = "0px 7px 8px -4px rgba(0, 0, 0, 0.2), 0px 12px 17px 2px rgba(0, 0, 0, 0.14), 0px 5px 22px 4px rgba(0, 0, 0, 0.12)";
const ShadowDp16 = "0px 8px 10px -5px rgba(0, 0, 0, 0.2), 0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12)";
const ShadowDp24 = "0px 11px 15px -7px rgba(0, 0, 0, 0.2), 0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12)";

const Shadow = /*#__PURE__*/Object.freeze({
    __proto__: null,
    ShadowHighlightLight: ShadowHighlightLight,
    ShadowHighlightLightHc: ShadowHighlightLightHc,
    ShadowHighlightDarkHc: ShadowHighlightDarkHc,
    ShadowHighlightDark: ShadowHighlightDark,
    ShadowDialogElevation: ShadowDialogElevation,
    ShadowMenuElevation: ShadowMenuElevation,
    ShadowDraggedElevation: ShadowDraggedElevation,
    ShadowTooltipElevation: ShadowTooltipElevation,
    ShadowAltDialogElevation: ShadowAltDialogElevation,
    ShadowCardElevation: ShadowCardElevation,
    ShadowDp1: ShadowDp1,
    ShadowDp2: ShadowDp2,
    ShadowDp4: ShadowDp4,
    ShadowDp6: ShadowDp6,
    ShadowDp8: ShadowDp8,
    ShadowDp12: ShadowDp12,
    ShadowDp16: ShadowDp16,
    ShadowDp24: ShadowDp24
});

const SpacingMicro = "4px";
const SpacingXs = "8px";
const SpacingS = "12px";
const SpacingBase = "16px";
const SpacingM = "20px";
const SpacingL = "24px";
const SpacingXl = "32px";
const SpacingXxl = "40px";

const Spacing = /*#__PURE__*/Object.freeze({
    __proto__: null,
    SpacingMicro: SpacingMicro,
    SpacingXs: SpacingXs,
    SpacingS: SpacingS,
    SpacingBase: SpacingBase,
    SpacingM: SpacingM,
    SpacingL: SpacingL,
    SpacingXl: SpacingXl,
    SpacingXxl: SpacingXxl
});

const StrokeS = "1px";
const StrokeM = "2px";
const StrokeL = "3px";
const StrokeXl = "4px";

const Stroke = /*#__PURE__*/Object.freeze({
    __proto__: null,
    StrokeS: StrokeS,
    StrokeM: StrokeM,
    StrokeL: StrokeL,
    StrokeXl: StrokeXl
});

/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/comma-dangle */
const HeaderVariants = {
    header1Bold: '1',
    header1: '1',
    header2Bold: '2',
    header2: '2',
    header3Bold: '3',
    header3: '3',
    header4Bold: '4',
    header4: '4',
    brandH4: '4',
};
var FontVariantToken;
(function (FontVariantToken) {
    FontVariantToken["fontSizeHeroBold"] = "heroBold";
    FontVariantToken["fontSizeHero"] = "hero";
    FontVariantToken["fontSizeH1Bold"] = "header1Bold";
    FontVariantToken["fontSizeH1"] = "header1";
    FontVariantToken["fontSizeH2Bold"] = "header2Bold";
    FontVariantToken["fontSizeH2"] = "header2";
    FontVariantToken["fontSizeH3Bold"] = "header3Bold";
    FontVariantToken["fontSizeH3"] = "header3";
    FontVariantToken["fontSizeH4Bold"] = "header4Bold";
    FontVariantToken["fontSizeH4"] = "header4";
    FontVariantToken["fontSizeLBold"] = "lBold";
    FontVariantToken["fontSizeL"] = "l";
    FontVariantToken["fontSizeMBold"] = "mBold";
    FontVariantToken["fontSizeM"] = "m";
    FontVariantToken["fontSizeLink"] = "link";
    FontVariantToken["fontSizeSBold"] = "sBold";
    FontVariantToken["fontSizeS"] = "s";
    FontVariantToken["fontSizeXsBold"] = "xsBold";
    FontVariantToken["fontSizeXs"] = "xs";
    FontVariantToken["fontBrandH4"] = "brandH4";
    FontVariantToken["fontBrandL"] = "brandL";
    FontVariantToken["fontBrandM"] = "brandM";
    FontVariantToken["fontMonoMBold"] = "monoMBold";
    FontVariantToken["fontMonoM"] = "monoM";
    FontVariantToken["fontMonoSBold"] = "monoSBold";
    FontVariantToken["fontMonoS"] = "monoS";
    FontVariantToken["fontMonoXSBold"] = "monoXSBold";
    FontVariantToken["fontMonoXS"] = "monoXS";
})(FontVariantToken || (FontVariantToken = {}));
const fontSizeHeroBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '60px',
    'lineHeight': '72px',
    'fontWeight': 400
};
const fontSizeHero = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '60px',
    'lineHeight': '72px',
    'fontWeight': 300
};
const fontSizeH1Bold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '36px',
    'lineHeight': '44px',
    'fontWeight': 400
};
const fontSizeH1 = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '36px',
    'lineHeight': '44px',
    'fontWeight': 300
};
const fontSizeH2Bold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '32px',
    'lineHeight': '40px',
    'fontWeight': 400
};
const fontSizeH2 = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '32px',
    'lineHeight': '40px',
    'fontWeight': 300
};
const fontSizeH3Bold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '24px',
    'lineHeight': '32px',
    'fontWeight': 700
};
const fontSizeH3 = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '24px',
    'lineHeight': '24px',
    'fontWeight': 400
};
const fontSizeH4Bold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '20px',
    'lineHeight': '24px',
    'fontWeight': 600
};
const fontSizeH4 = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '20px',
    'lineHeight': '24px',
    'fontWeight': 400
};
const fontSizeLBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '16px',
    'lineHeight': '24px',
    'fontWeight': 600
};
const fontSizeL = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '16px',
    'lineHeight': '24px',
    'fontWeight': 400
};
const fontSizeMBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 600
};
const fontSizeM = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 400
};
const fontSizeLink = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 600
};
const fontSizeSBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '12px',
    'lineHeight': '16px',
    'fontWeight': 600
};
const fontSizeS = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '12px',
    'lineHeight': '16px',
    'fontWeight': 400
};
const fontSizeXsBold = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '10px',
    'lineHeight': '16px',
    'fontWeight': 600
};
const fontSizeXs = {
    'fontFamily': 'noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\',  \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '10px',
    'lineHeight': '16px',
    'fontWeight': 400
};
const fontBrandH4 = {
    'fontFamily': 'poppins, noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\', \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '20px',
    'lineHeight': '24px',
    'letterSpacing': '-0.528px',
    'fontWeight': 600
};
const fontBrandL = {
    'fontFamily': 'poppins, noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\', \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '16px',
    'lineHeight': '24px',
    'fontWeight': 600
};
const fontBrandM = {
    'fontFamily': 'poppins, noto-sans, \'Noto Sans JP\', \'Noto Sans KR\', \'Noto Sans SC\', \'Noto Sans TC\', \'Noto Sans\', -apple-system, system-ui, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial,sans-serif',
    'fontSize': '14px',
    'lineHeight': '24px',
    'fontWeight': 500
};
const fontMonoMBold = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 700
};
const fontMonoM = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '14px',
    'lineHeight': '20px',
    'fontWeight': 400
};
const fontMonoSBold = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '12px',
    'lineHeight': '16px',
    'fontWeight': 700
};
const fontMonoS = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '12px',
    'lineHeight': '16px',
    'fontWeight': 400
};
const fontMonoXSBold = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '10px',
    'lineHeight': '16px',
    'fontWeight': 700
};
const fontMonoXS = {
    'fontFamily': 'inconsolata, monospace',
    'fontSize': '10px',
    'lineHeight': '16px',
    'fontWeight': 400
};

const Typography = /*#__PURE__*/Object.freeze({
    __proto__: null,
    HeaderVariants: HeaderVariants,
    get FontVariantToken () { return FontVariantToken; },
    fontSizeHeroBold: fontSizeHeroBold,
    fontSizeHero: fontSizeHero,
    fontSizeH1Bold: fontSizeH1Bold,
    fontSizeH1: fontSizeH1,
    fontSizeH2Bold: fontSizeH2Bold,
    fontSizeH2: fontSizeH2,
    fontSizeH3Bold: fontSizeH3Bold,
    fontSizeH3: fontSizeH3,
    fontSizeH4Bold: fontSizeH4Bold,
    fontSizeH4: fontSizeH4,
    fontSizeLBold: fontSizeLBold,
    fontSizeL: fontSizeL,
    fontSizeMBold: fontSizeMBold,
    fontSizeM: fontSizeM,
    fontSizeLink: fontSizeLink,
    fontSizeSBold: fontSizeSBold,
    fontSizeS: fontSizeS,
    fontSizeXsBold: fontSizeXsBold,
    fontSizeXs: fontSizeXs,
    fontBrandH4: fontBrandH4,
    fontBrandL: fontBrandL,
    fontBrandM: fontBrandM,
    fontMonoMBold: fontMonoMBold,
    fontMonoM: fontMonoM,
    fontMonoSBold: fontMonoSBold,
    fontMonoS: fontMonoS,
    fontMonoXSBold: fontMonoXSBold,
    fontMonoXS: fontMonoXS
});

const token = {
    Colors,
    ScreenSizes,
    FontFamily,
    Border,
    Icon,
    Padding,
    Shadow,
    Stroke,
    Spacing,
    Typography,
    FontVariantToken,
    HeaderVariants,
};

export { ColorErrorTextLight as $, ColorForegroundDeEmpLight as A, ColorForegroundDisableLight as B, ColorBackgroundLight as C, ColorForegroundInverseLight as D, ColorForegroundHighlightLight as E, FontVariantToken as F, ColorForegroundHighlightSelectedLight as G, HeaderVariants as H, ColorForegroundHighlightSelectedHoverLight as I, ColorForegroundLinkLight as J, ColorForegroundLinkPressedLight as K, ColorForegroundInvDeEmpLight as L, ColorPrimaryLight as M, ColorPrimaryLighterLight as N, ColorPrimaryDarkerLight as O, ColorPrimaryHoverLight as P, ColorPrimaryFocusedLight as Q, ColorPrimaryPressedLight as R, ColorSecondaryFocusedLight as S, ColorSecondaryPressedLight as T, ColorChipDefaultBackgroundLight as U, ColorChipErrorBackgroundLight as V, ColorChipWarningBackgroundLight as W, ColorChipInfoBackgroundLight as X, ColorChipSuccessBackgroundLight as Y, ColorErrorIconLight as Z, ColorErrorIconInverseLight as _, ColorBackgroundSecondaryLight as a, ColorError500 as a$, ColorErrorBackgroundLight as a0, ColorErrorForegroundInverseLight as a1, ColorInfoForegroundLight as a2, ColorInfoIconLight as a3, ColorInfoIconInverseLight as a4, ColorInfoTextLight as a5, ColorInfoForegroundInverseLight as a6, ColorInfoBackgroundLight as a7, ColorSuccessIconLight as a8, ColorSuccessIconInverseLight as a9, ColorCodeFunctionLight as aA, ColorCodeOperatorLight as aB, ColorCodeNumericLight as aC, ColorCodeTextLight as aD, ColorToggleThumbOffLight as aE, ColorToggleTrackOffLight as aF, ColorToggleThumbOnLight as aG, ColorToggleTrackOnLight as aH, ColorToggleThumbOffDisabledLight as aI, ColorToggleTrackOffDisabledLight as aJ, ColorToggleThumbOnDisabledLight as aK, ColorToggleTrackOnDisabledLight as aL, ColorSkeletonLight as aM, ColorSkeletonGlowLight as aN, ColorDataGridHoverLight as aO, ColorDataGridPressedLight as aP, ColorFocusIndicatorLight as aQ, ColorFocusIndicatorInverseLight as aR, ColorChartPurpleLight as aS, ColorChartPinkLight as aT, ColorChartBlueSecondaryLight as aU, ColorChartLightBlueLight as aV, ColorChartGreenLight as aW, ColorChartYellowLight as aX, ColorWhite as aY, ColorPrimaryLighterDark as aZ, ColorError250 as a_, ColorSuccessTextLight as aa, ColorSuccessBackgroundLight as ab, ColorSuccessForegroundInverseLight as ac, ColorWarningIconLight as ad, ColorWarningIconInverseLight as ae, ColorWarningTextLight as af, ColorWarningBackgroundLight as ag, ColorWarningForegroundInverseLight as ah, ColorIconDefaultLight as ai, ColorIconInvertedDefaultLight as aj, ColorToggleOffHoverLight as ak, ColorToggleOffFocusLight as al, ColorToggleOffPressedLight as am, ColorToggleOnHoverLight as an, ColorToggleOnFocusLight as ao, ColorToggleOnPressedLight as ap, ColorCalloutBackgroundLight as aq, ColorWarnLight as ar, ColorWarnDarkerLight as as, ColorWarnHoverLight as at, ColorWarnFocusLight as au, ColorWarnPressedLight as av, ColorCarouselBackgroundLight as aw, ColorIconButtonHoverLight as ax, ColorIconButtonFocusLight as ay, ColorIconButtonPressedLight as az, ColorBackgroundInverseLight as b, ColorPurple800 as b$, ColorError750 as b0, ColorGreen250 as b1, ColorGreen500 as b2, ColorGreen750 as b3, ColorWarning300 as b4, ColorWarning500 as b5, ColorWarning700 as b6, ColorBlack as b7, ColorInfo700 as b8, ColorOrange100 as b9, ColorGreen400 as bA, ColorGreen600 as bB, ColorGreen700 as bC, ColorGreen800 as bD, ColorYellow100 as bE, ColorYellow200 as bF, ColorYellow300 as bG, ColorYellow400 as bH, ColorYellow500 as bI, ColorYellow600 as bJ, ColorYellow700 as bK, ColorYellow800 as bL, ColorRed100 as bM, ColorRed200 as bN, ColorRed300 as bO, ColorRed400 as bP, ColorRed500 as bQ, ColorRed600 as bR, ColorRed700 as bS, ColorRed800 as bT, ColorPurple100 as bU, ColorPurple200 as bV, ColorPurple300 as bW, ColorPurple400 as bX, ColorPurple500 as bY, ColorPurple600 as bZ, ColorPurple700 as b_, ColorOrange200 as ba, ColorOrange300 as bb, ColorOrange400 as bc, ColorOrange500 as bd, ColorOrange600 as be, ColorOrange700 as bf, ColorOrange800 as bg, ColorBlue100 as bh, ColorBlue200 as bi, ColorBlue300 as bj, ColorBlue400 as bk, ColorBlue500 as bl, ColorBlue600 as bm, ColorBlue700 as bn, ColorBlue800 as bo, ColorBlueSecondary100 as bp, ColorBlueSecondary200 as bq, ColorBlueSecondary300 as br, ColorBlueSecondary400 as bs, ColorBlueSecondary500 as bt, ColorBlueSecondary600 as bu, ColorBlueSecondary700 as bv, ColorBlueSecondary800 as bw, ColorGreen100 as bx, ColorGreen200 as by, ColorGreen300 as bz, ColorBackgroundGrayLight as c, ColorChipInfoBackgroundLightHc as c$, ColorLightBlue100 as c0, ColorLightBlue200 as c1, ColorLightBlue300 as c2, ColorLightBlue400 as c3, ColorLightBlue500 as c4, ColorLightBlue600 as c5, ColorLightBlue700 as c6, ColorLightBlue800 as c7, ColorInk100 as c8, ColorInk150 as c9, ColorBorderGridLightHc as cA, ColorBorderDeEmpLightHc as cB, ColorSelectionLightHc as cC, ColorLogoLightHc as cD, ColorForegroundLightHc as cE, ColorForegroundLightLightHc as cF, ColorForegroundEmpLightHc as cG, ColorForegroundDeEmpLightHc as cH, ColorForegroundDisableLightHc as cI, ColorForegroundInverseLightHc as cJ, ColorForegroundHighlightLightHc as cK, ColorForegroundHighlightSelectedLightHc as cL, ColorForegroundHighlightSelectedHoverLightHc as cM, ColorForegroundLinkLightHc as cN, ColorForegroundLinkPressedLightHc as cO, ColorForegroundInvDeEmpLightHc as cP, ColorPrimaryLightHc as cQ, ColorPrimaryLighterLightHc as cR, ColorPrimaryDarkerLightHc as cS, ColorPrimaryHoverLightHc as cT, ColorPrimaryFocusedLightHc as cU, ColorPrimaryPressedLightHc as cV, ColorSecondaryFocusedLightHc as cW, ColorSecondaryPressedLightHc as cX, ColorChipDefaultBackgroundLightHc as cY, ColorChipErrorBackgroundLightHc as cZ, ColorChipWarningBackgroundLightHc as c_, ColorInk300 as ca, ColorInk400 as cb, ColorInk450 as cc, ColorInk550 as cd, ColorInk600 as ce, ColorInk650 as cf, ColorInk700 as cg, ColorBackgroundLightHc as ch, ColorBackgroundSecondaryLightHc as ci, ColorBackgroundInverseLightHc as cj, ColorBackgroundGrayLightHc as ck, ColorBackgroundDisabledLightHc as cl, ColorBackgroundHighlightLightHc as cm, ColorBackgroundRaisedLightHc as cn, ColorBackgroundEditLightHc as co, ColorBackgroundGrayEmpLightHc as cp, ColorBackgroundHoverLightHc as cq, ColorBackgroundPressedLightHc as cr, ColorBackgroundSelectedLightHc as cs, ColorSelectionIndicatorLightHc as ct, ColorNotificationBadgeLightHc as cu, ColorNotificationIndicatorLightHc as cv, ColorHoverLightHc as cw, ColorCurtainLightHc as cx, ColorBorderLightHc as cy, ColorBorderDisabledLightHc as cz, ColorBackgroundDisabledLight as d, ColorChartGreenLightHc as d$, ColorChipSuccessBackgroundLightHc as d0, ColorErrorIconLightHc as d1, ColorErrorIconInverseLightHc as d2, ColorErrorTextLightHc as d3, ColorErrorBackgroundLightHc as d4, ColorErrorForegroundInverseLightHc as d5, ColorInfoForegroundLightHc as d6, ColorInfoIconLightHc as d7, ColorInfoIconInverseLightHc as d8, ColorInfoTextLightHc as d9, ColorWarnPressedLightHc as dA, ColorCarouselBackgroundLightHc as dB, ColorIconButtonHoverLightHc as dC, ColorIconButtonFocusLightHc as dD, ColorIconButtonPressedLightHc as dE, ColorCodeFunctionLightHc as dF, ColorCodeOperatorLightHc as dG, ColorCodeNumericLightHc as dH, ColorCodeTextLightHc as dI, ColorToggleThumbOffLightHc as dJ, ColorToggleTrackOffLightHc as dK, ColorToggleThumbOnLightHc as dL, ColorToggleTrackOnLightHc as dM, ColorToggleThumbOffDisabledLightHc as dN, ColorToggleTrackOffDisabledLightHc as dO, ColorToggleThumbOnDisabledLightHc as dP, ColorToggleTrackOnDisabledLightHc as dQ, ColorSkeletonLightHc as dR, ColorSkeletonGlowLightHc as dS, ColorDataGridHoverLightHc as dT, ColorDataGridPressedLightHc as dU, ColorFocusIndicatorLightHc as dV, ColorFocusIndicatorInverseLightHc as dW, ColorChartPurpleLightHc as dX, ColorChartPinkLightHc as dY, ColorChartBlueSecondaryLightHc as dZ, ColorChartLightBlueLightHc as d_, ColorInfoForegroundInverseLightHc as da, ColorInfoBackgroundLightHc as db, ColorSuccessIconLightHc as dc, ColorSuccessIconInverseLightHc as dd, ColorSuccessTextLightHc as de, ColorSuccessBackgroundLightHc as df, ColorSuccessForegroundInverseLightHc as dg, ColorWarningIconLightHc as dh, ColorWarningIconInverseLightHc as di, ColorWarningTextLightHc as dj, ColorWarningBackgroundLightHc as dk, ColorWarningForegroundInverseLightHc as dl, ColorIconDefaultLightHc as dm, ColorIconInvertedDefaultLightHc as dn, ColorToggleOffHoverLightHc as dp, ColorToggleOffFocusLightHc as dq, ColorToggleOffPressedLightHc as dr, ColorToggleOnHoverLightHc as ds, ColorToggleOnFocusLightHc as dt, ColorToggleOnPressedLightHc as du, ColorCalloutBackgroundLightHc as dv, ColorWarnLightHc as dw, ColorWarnDarkerLightHc as dx, ColorWarnHoverLightHc as dy, ColorWarnFocusLightHc as dz, ColorBackgroundHighlightLight as e, ColorSuccessForegroundInverseDark as e$, ColorChartYellowLightHc as e0, ColorBackgroundDark as e1, ColorBackgroundSecondaryDark as e2, ColorBackgroundInverseDark as e3, ColorBackgroundGrayDark as e4, ColorBackgroundDisabledDark as e5, ColorBackgroundHighlightDark as e6, ColorBackgroundRaisedDark as e7, ColorBackgroundEditDark as e8, ColorBackgroundGrayEmpDark as e9, ColorPrimaryDark as eA, ColorPrimaryDarkerDark as eB, ColorPrimaryHoverDark as eC, ColorPrimaryFocusedDark as eD, ColorPrimaryPressedDark as eE, ColorSecondaryFocusedDark as eF, ColorSecondaryPressedDark as eG, ColorChipDefaultBackgroundDark as eH, ColorChipErrorBackgroundDark as eI, ColorChipWarningBackgroundDark as eJ, ColorChipInfoBackgroundDark as eK, ColorChipSuccessBackgroundDark as eL, ColorErrorIconDark as eM, ColorErrorIconInverseDark as eN, ColorErrorTextDark as eO, ColorErrorBackgroundDark as eP, ColorErrorForegroundInverseDark as eQ, ColorInfoForegroundDark as eR, ColorInfoIconDark as eS, ColorInfoIconInverseDark as eT, ColorInfoTextDark as eU, ColorInfoForegroundInverseDark as eV, ColorInfoBackgroundDark as eW, ColorSuccessIconDark as eX, ColorSuccessIconInverseDark as eY, ColorSuccessTextDark as eZ, ColorSuccessBackgroundDark as e_, ColorBackgroundHoverDark as ea, ColorBackgroundPressedDark as eb, ColorBackgroundSelectedDark as ec, ColorSelectionIndicatorDark as ed, ColorNotificationBadgeDark as ee, ColorNotificationIndicatorDark as ef, ColorHoverDark as eg, ColorCurtainDark as eh, ColorBorderDark as ei, ColorBorderDisabledDark as ej, ColorBorderGridDark as ek, ColorBorderDeEmpDark as el, ColorSelectionDark as em, ColorLogoDark as en, ColorForegroundDark as eo, ColorForegroundLightDark as ep, ColorForegroundEmpDark as eq, ColorForegroundDeEmpDark as er, ColorForegroundDisableDark as es, ColorForegroundInverseDark as et, ColorForegroundHighlightDark as eu, ColorForegroundHighlightSelectedDark as ev, ColorForegroundHighlightSelectedHoverDark as ew, ColorForegroundLinkDark as ex, ColorForegroundLinkPressedDark as ey, ColorForegroundInvDeEmpDark as ez, ColorBackgroundRaisedLight as f, ColorCurtainDarkHc as f$, ColorWarningIconDark as f0, ColorWarningIconInverseDark as f1, ColorWarningTextDark as f2, ColorWarningBackgroundDark as f3, ColorWarningForegroundInverseDark as f4, ColorIconDefaultDark as f5, ColorIconInvertedDefaultDark as f6, ColorToggleOffHoverDark as f7, ColorToggleOffFocusDark as f8, ColorToggleOffPressedDark as f9, ColorSkeletonGlowDark as fA, ColorDataGridHoverDark as fB, ColorDataGridPressedDark as fC, ColorFocusIndicatorDark as fD, ColorFocusIndicatorInverseDark as fE, ColorChartPurpleDark as fF, ColorChartPinkDark as fG, ColorChartBlueSecondaryDark as fH, ColorChartLightBlueDark as fI, ColorChartGreenDark as fJ, ColorChartYellowDark as fK, ColorBackgroundDarkHc as fL, ColorBackgroundSecondaryDarkHc as fM, ColorBackgroundInverseDarkHc as fN, ColorBackgroundGrayDarkHc as fO, ColorBackgroundDisabledDarkHc as fP, ColorBackgroundHighlightDarkHc as fQ, ColorBackgroundRaisedDarkHc as fR, ColorBackgroundEditDarkHc as fS, ColorBackgroundGrayEmpDarkHc as fT, ColorBackgroundHoverDarkHc as fU, ColorBackgroundPressedDarkHc as fV, ColorBackgroundSelectedDarkHc as fW, ColorSelectionIndicatorDarkHc as fX, ColorNotificationBadgeDarkHc as fY, ColorNotificationIndicatorDarkHc as fZ, ColorHoverDarkHc as f_, ColorToggleOnHoverDark as fa, ColorToggleOnFocusDark as fb, ColorToggleOnPressedDark as fc, ColorCalloutBackgroundDark as fd, ColorWarnDark as fe, ColorWarnDarkerDark as ff, ColorWarnHoverDark as fg, ColorWarnFocusDark as fh, ColorWarnPressedDark as fi, ColorCarouselBackgroundDark as fj, ColorIconButtonHoverDark as fk, ColorIconButtonFocusDark as fl, ColorIconButtonPressedDark as fm, ColorCodeFunctionDark as fn, ColorCodeOperatorDark as fo, ColorCodeNumericDark as fp, ColorCodeTextDark as fq, ColorToggleThumbOffDark as fr, ColorToggleTrackOffDark as fs, ColorToggleThumbOnDark as ft, ColorToggleTrackOnDark as fu, ColorToggleThumbOffDisabledDark as fv, ColorToggleTrackOffDisabledDark as fw, ColorToggleThumbOnDisabledDark as fx, ColorToggleTrackOnDisabledDark as fy, ColorSkeletonDark as fz, ColorBackgroundEditLight as g, ColorWarnHoverDarkHc as g$, ColorBorderDarkHc as g0, ColorBorderDisabledDarkHc as g1, ColorBorderGridDarkHc as g2, ColorBorderDeEmpDarkHc as g3, ColorSelectionDarkHc as g4, ColorLogoDarkHc as g5, ColorForegroundDarkHc as g6, ColorForegroundLightDarkHc as g7, ColorForegroundEmpDarkHc as g8, ColorForegroundDeEmpDarkHc as g9, ColorInfoForegroundDarkHc as gA, ColorInfoIconDarkHc as gB, ColorInfoIconInverseDarkHc as gC, ColorInfoTextDarkHc as gD, ColorInfoForegroundInverseDarkHc as gE, ColorInfoBackgroundDarkHc as gF, ColorSuccessIconDarkHc as gG, ColorSuccessIconInverseDarkHc as gH, ColorSuccessTextDarkHc as gI, ColorSuccessBackgroundDarkHc as gJ, ColorSuccessForegroundInverseDarkHc as gK, ColorWarningIconDarkHc as gL, ColorWarningIconInverseDarkHc as gM, ColorWarningTextDarkHc as gN, ColorWarningBackgroundDarkHc as gO, ColorWarningForegroundInverseDarkHc as gP, ColorIconDefaultDarkHc as gQ, ColorIconInvertedDefaultDarkHc as gR, ColorToggleOffHoverDarkHc as gS, ColorToggleOffFocusDarkHc as gT, ColorToggleOffPressedDarkHc as gU, ColorToggleOnHoverDarkHc as gV, ColorToggleOnFocusDarkHc as gW, ColorToggleOnPressedDarkHc as gX, ColorCalloutBackgroundDarkHc as gY, ColorWarnDarkHc as gZ, ColorWarnDarkerDarkHc as g_, ColorForegroundDisableDarkHc as ga, ColorForegroundInverseDarkHc as gb, ColorForegroundHighlightDarkHc as gc, ColorForegroundHighlightSelectedDarkHc as gd, ColorForegroundHighlightSelectedHoverDarkHc as ge, ColorForegroundLinkDarkHc as gf, ColorForegroundLinkPressedDarkHc as gg, ColorForegroundInvDeEmpDarkHc as gh, ColorPrimaryDarkHc as gi, ColorPrimaryLighterDarkHc as gj, ColorPrimaryDarkerDarkHc as gk, ColorPrimaryHoverDarkHc as gl, ColorPrimaryFocusedDarkHc as gm, ColorPrimaryPressedDarkHc as gn, ColorSecondaryFocusedDarkHc as go, ColorSecondaryPressedDarkHc as gp, ColorChipDefaultBackgroundDarkHc as gq, ColorChipErrorBackgroundDarkHc as gr, ColorChipWarningBackgroundDarkHc as gs, ColorChipInfoBackgroundDarkHc as gt, ColorChipSuccessBackgroundDarkHc as gu, ColorErrorIconDarkHc as gv, ColorErrorIconInverseDarkHc as gw, ColorErrorTextDarkHc as gx, ColorErrorBackgroundDarkHc as gy, ColorErrorForegroundInverseDarkHc as gz, ColorBackgroundGrayEmpLight as h, ColorWarnFocusDarkHc as h0, ColorWarnPressedDarkHc as h1, ColorCarouselBackgroundDarkHc as h2, ColorIconButtonHoverDarkHc as h3, ColorIconButtonFocusDarkHc as h4, ColorIconButtonPressedDarkHc as h5, ColorCodeFunctionDarkHc as h6, ColorCodeOperatorDarkHc as h7, ColorCodeNumericDarkHc as h8, ColorCodeTextDarkHc as h9, ColorToggleThumbOffDarkHc as ha, ColorToggleTrackOffDarkHc as hb, ColorToggleThumbOnDarkHc as hc, ColorToggleTrackOnDarkHc as hd, ColorToggleThumbOffDisabledDarkHc as he, ColorToggleTrackOffDisabledDarkHc as hf, ColorToggleThumbOnDisabledDarkHc as hg, ColorToggleTrackOnDisabledDarkHc as hh, ColorSkeletonDarkHc as hi, ColorSkeletonGlowDarkHc as hj, ColorDataGridHoverDarkHc as hk, ColorDataGridPressedDarkHc as hl, ColorFocusIndicatorDarkHc as hm, ColorFocusIndicatorInverseDarkHc as hn, ColorChartPurpleDarkHc as ho, ColorChartPinkDarkHc as hp, ColorChartBlueSecondaryDarkHc as hq, ColorChartLightBlueDarkHc as hr, ColorChartGreenDarkHc as hs, ColorChartYellowDarkHc as ht, FontNormal as hu, SpacingXs as hv, SpacingXl as hw, SpacingL as hx, SpacingXxl as hy, ColorBackgroundHoverLight as i, ColorBackgroundPressedLight as j, ColorBackgroundSelectedLight as k, ColorSelectionIndicatorLight as l, ColorNotificationBadgeLight as m, ColorNotificationIndicatorLight as n, ColorHoverLight as o, ColorCurtainLight as p, ColorBorderLight as q, ColorBorderDisabledLight as r, ColorBorderGridLight as s, token as t, ColorBorderDeEmpLight as u, ColorSelectionLight as v, ColorLogoLight as w, ColorForegroundLight as x, ColorForegroundLightLight as y, ColorForegroundEmpLight as z };

//# sourceMappingURL=index-7579d57b.js.map